/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddBulkDashboardUser } from '../models/AddBulkDashboardUser';
import type { AddNewDashboardUser } from '../models/AddNewDashboardUser';
import type { AddOrRemoveRequestItems } from '../models/AddOrRemoveRequestItems';
import type { AdminDelegateDocumentRequest } from '../models/AdminDelegateDocumentRequest';
import type { AIClassification } from '../models/AIClassification';
import type { AllocationCompanyModel } from '../models/AllocationCompanyModel';
import type { AllocationConclusionModel } from '../models/AllocationConclusionModel';
import type { AllocationModel } from '../models/AllocationModel';
import type { AllocationName } from '../models/AllocationName';
import type { ApiCreateDocumentGenerationJob } from '../models/ApiCreateDocumentGenerationJob';
import type { AutoUpdatedFirmReportZipModel } from '../models/AutoUpdatedFirmReportZipModel';
import type { AvailableAllocation } from '../models/AvailableAllocation';
import type { BulkValuationUpdate } from '../models/BulkValuationUpdate';
import type { BulkValuationUpdateResponse } from '../models/BulkValuationUpdateResponse';
import type { CapTableDetailsModel } from '../models/CapTableDetailsModel';
import type { CapTableFundOwnership } from '../models/CapTableFundOwnership';
import type { CapTableGrossIRRResponse } from '../models/CapTableGrossIRRResponse';
import type { CapTableModel } from '../models/CapTableModel';
import type { CapTableName } from '../models/CapTableName';
import type { CapTableSecurities } from '../models/CapTableSecurities';
import type { CashFlowLedgerBulkSave } from '../models/CashFlowLedgerBulkSave';
import type { CashFlowLedgerItem } from '../models/CashFlowLedgerItem';
import type { ChoiceAnswerModel } from '../models/ChoiceAnswerModel';
import type { ClassificationApproval } from '../models/ClassificationApproval';
import type { ClassifyDocument } from '../models/ClassifyDocument';
import type { CompaniesByFirm } from '../models/CompaniesByFirm';
import type { Company } from '../models/Company';
import type { CompanyDocuments } from '../models/CompanyDocuments';
import type { CompanyMeasurementDateModel } from '../models/CompanyMeasurementDateModel';
import type { CompanyMeasurementDateName } from '../models/CompanyMeasurementDateName';
import type { CompanyMeasurementDateNameNullable } from '../models/CompanyMeasurementDateNameNullable';
import type { CompanyPrimaryContact } from '../models/CompanyPrimaryContact';
import type { CompanyQuestionSync } from '../models/CompanyQuestionSync';
import type { CompanyRequestedDocumentModel } from '../models/CompanyRequestedDocumentModel';
import type { CompanyRequestedInformation } from '../models/CompanyRequestedInformation';
import type { CompanyWithMeasurementDates } from '../models/CompanyWithMeasurementDates';
import type { CompGroupListCreate } from '../models/CompGroupListCreate';
import type { Create409Report } from '../models/Create409Report';
import type { CreateCompanyInformationRequest } from '../models/CreateCompanyInformationRequest';
import type { CreateDocumentAndQuestionnaireTasks } from '../models/CreateDocumentAndQuestionnaireTasks';
import type { CreateFirmRequests } from '../models/CreateFirmRequests';
import type { CreateOnboardingTasks } from '../models/CreateOnboardingTasks';
import type { CreateOrDeleteDocumentReferenceObject } from '../models/CreateOrDeleteDocumentReferenceObject';
import type { CustomBreakpoints } from '../models/CustomBreakpoints';
import type { CustomPrimaryUser } from '../models/CustomPrimaryUser';
import type { CustomUser } from '../models/CustomUser';
import type { DelegateDocumentRequest } from '../models/DelegateDocumentRequest';
import type { DelegateQuestionnaire } from '../models/DelegateQuestionnaire';
import type { DocumentReferenceClassification } from '../models/DocumentReferenceClassification';
import type { DocumentReferenceObjectView } from '../models/DocumentReferenceObjectView';
import type { DocumentRequestView } from '../models/DocumentRequestView';
import type { EffectiveTaxRateModel } from '../models/EffectiveTaxRateModel';
import type { EffectiveTaxRateWriteModel } from '../models/EffectiveTaxRateWriteModel';
import type { EquityValue } from '../models/EquityValue';
import type { ExcelExportExtendedModel } from '../models/ExcelExportExtendedModel';
import type { ExcelExportsRequested } from '../models/ExcelExportsRequested';
import type { ExcelExportStartInputData } from '../models/ExcelExportStartInputData';
import type { ExtendedCompanyInfo } from '../models/ExtendedCompanyInfo';
import type { FileModel } from '../models/FileModel';
import type { FileUpdateRequestedFiles } from '../models/FileUpdateRequestedFiles';
import type { FinancialStatementBasicData } from '../models/FinancialStatementBasicData';
import type { FinancialStatementFullRead } from '../models/FinancialStatementFullRead';
import type { FinancialStatementFullWrite } from '../models/FinancialStatementFullWrite';
import type { FinancialStatementSmall } from '../models/FinancialStatementSmall';
import type { FinancialStatementVersionValidator } from '../models/FinancialStatementVersionValidator';
import type { Firm } from '../models/Firm';
import type { FirmCompaniesRequestsProgress } from '../models/FirmCompaniesRequestsProgress';
import type { FirmCompany } from '../models/FirmCompany';
import type { FirmCompanyMeasurementDate } from '../models/FirmCompanyMeasurementDate';
import type { FirmRequestedDocumentModel } from '../models/FirmRequestedDocumentModel';
import type { FirmRequestsView } from '../models/FirmRequestsView';
import type { FirmStepper } from '../models/FirmStepper';
import type { FirmSummaryRead } from '../models/FirmSummaryRead';
import type { FirmUserPermission } from '../models/FirmUserPermission';
import type { FolderModel } from '../models/FolderModel';
import type { FolderView } from '../models/FolderView';
import type { Fulfillment } from '../models/Fulfillment';
import type { Fund } from '../models/Fund';
import type { FundByMeasurementDate } from '../models/FundByMeasurementDate';
import type { FundMeasurementDateName } from '../models/FundMeasurementDateName';
import type { FundName } from '../models/FundName';
import type { FundSummary } from '../models/FundSummary';
import type { GPC } from '../models/GPC';
import type { GPCPeriods } from '../models/GPCPeriods';
import type { IndividualRequestedFile } from '../models/IndividualRequestedFile';
import type { InformationRequestStatus } from '../models/InformationRequestStatus';
import type { IntegrationMetadata } from '../models/IntegrationMetadata';
import type { Investment } from '../models/Investment';
import type { InvestmentCompanyInfo } from '../models/InvestmentCompanyInfo';
import type { JobStatusResponse } from '../models/JobStatusResponse';
import type { MeasurementDateExistsReturn } from '../models/MeasurementDateExistsReturn';
import type { MeasurementDateExtended } from '../models/MeasurementDateExtended';
import type { MeasurementDateName } from '../models/MeasurementDateName';
import type { MeasurementDateRollover } from '../models/MeasurementDateRollover';
import type { MeasurementDateRolloverReturn } from '../models/MeasurementDateRolloverReturn';
import type { MultiAllocationInputSerializer } from '../models/MultiAllocationInputSerializer';
import type { NewValuationAllocationVersion } from '../models/NewValuationAllocationVersion';
import type { Note } from '../models/Note';
import type { NoteGet } from '../models/NoteGet';
import type { NumberFriendlyCreateCompanyQuestion } from '../models/NumberFriendlyCreateCompanyQuestion';
import type { Portal } from '../models/Portal';
import type { PresignedURL } from '../models/PresignedURL';
import type { ProFormaCapTableModel } from '../models/ProFormaCapTableModel';
import type { RedelegateDocumentRequest } from '../models/RedelegateDocumentRequest';
import type { RedelegateQuestionnaire } from '../models/RedelegateQuestionnaire';
import type { RefreshComps } from '../models/RefreshComps';
import type { RetrieveDocumentExecutionSession } from '../models/RetrieveDocumentExecutionSession';
import type { RetrieveDocumentGenerationJob } from '../models/RetrieveDocumentGenerationJob';
import type { ScalarOpinionView } from '../models/ScalarOpinionView';
import type { Scenario } from '../models/Scenario';
import type { ScenarioValuesCalculation } from '../models/ScenarioValuesCalculation';
import type { SCIMConfigurationRead } from '../models/SCIMConfigurationRead';
import type { SCIMConfigurationUpdate } from '../models/SCIMConfigurationUpdate';
import type { SetReadyForAudit } from '../models/SetReadyForAudit';
import type { SheetAttributeMapping } from '../models/SheetAttributeMapping';
import type { SheetAttributeMappingUpsert } from '../models/SheetAttributeMappingUpsert';
import type { SlimUser } from '../models/SlimUser';
import type { SpreadsheetNote } from '../models/SpreadsheetNote';
import type { SpreadsheetNoteGet } from '../models/SpreadsheetNoteGet';
import type { TaskDetailedProgress } from '../models/TaskDetailedProgress';
import type { TaskModel } from '../models/TaskModel';
import type { TenantDiscovery } from '../models/TenantDiscovery';
import type { TenantDiscoveryResponse } from '../models/TenantDiscoveryResponse';
import type { TenantInformation } from '../models/TenantInformation';
import type { TimeSeriesResponse } from '../models/TimeSeriesResponse';
import type { TokenExchangeRequest } from '../models/TokenExchangeRequest';
import type { TokenExchangeResponse } from '../models/TokenExchangeResponse';
import type { TransactionId } from '../models/TransactionId';
import type { UpdateCompanyQuestion } from '../models/UpdateCompanyQuestion';
import type { UpdateDecisionsView } from '../models/UpdateDecisionsView';
import type { UpdateDocumentAndQuestionnaireTasks } from '../models/UpdateDocumentAndQuestionnaireTasks';
import type { UpdateFirmQuestion } from '../models/UpdateFirmQuestion';
import type { UpdateFundOwnershipResponse } from '../models/UpdateFundOwnershipResponse';
import type { UpdateIndividualQuestion } from '../models/UpdateIndividualQuestion';
import type { UpdateScalarOpinionClientsAuthorized } from '../models/UpdateScalarOpinionClientsAuthorized';
import type { UserFirmRole } from '../models/UserFirmRole';
import type { UserFulfillmentRequest } from '../models/UserFulfillmentRequest';
import type { UserNoteGet } from '../models/UserNoteGet';
import type { UserPermission } from '../models/UserPermission';
import type { UserPermissionWithPath } from '../models/UserPermissionWithPath';
import type { UserWithPermissions } from '../models/UserWithPermissions';
import type { ValuationAllocationModel } from '../models/ValuationAllocationModel';
import type { ValuationApproachModel } from '../models/ValuationApproachModel';
import type { ValuationModel } from '../models/ValuationModel';
import type { ValuationOpinionModule } from '../models/ValuationOpinionModule';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApiService {
  /**
   * @param data
   * @returns Scenario
   * @throws ApiError
   */
  public static apiAllocationScenarioAllocationResultsCreate(
    data: ScenarioValuesCalculation,
  ): CancelablePromise<Scenario> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/allocation-scenario/allocation-results',
      body: data,
    });
  }
  /**
   * @param data
   * @returns EquityValue
   * @throws ApiError
   */
  public static apiAllocationsCalculateBacksolveCreate(
    data: MultiAllocationInputSerializer,
  ): CancelablePromise<EquityValue> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/allocations/calculate-backsolve',
      body: data,
    });
  }
  /**
   * @param data
   * @returns AllocationConclusionModel
   * @throws ApiError
   */
  public static apiAllocationsFinalUpdate(
    data: AllocationConclusionModel,
  ): CancelablePromise<AllocationConclusionModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/allocations/final',
      body: data,
    });
  }
  /**
   * @param data
   * @returns AllocationConclusionModel
   * @throws ApiError
   */
  public static apiAllocationsFinalPartialUpdate(
    data: AllocationConclusionModel,
  ): CancelablePromise<AllocationConclusionModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/allocations/final',
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this allocation.
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsRead(
    id: number,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/allocations/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this allocation.
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsUpdate(
    id: number,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/allocations/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this allocation.
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsPartialUpdate(
    id: number,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/allocations/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsPublishedUpdate(
    id: string,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/allocations/{id}/published',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsPublishedPartialUpdate(
    id: string,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/allocations/{id}/published',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * Create a new analyst note.
   * POST /api/analyst-notes/
   * @param data
   * @returns UserNoteGet
   * @throws ApiError
   */
  public static apiAnalystNotesCreate(
    data: UserNoteGet,
  ): CancelablePromise<UserNoteGet> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/analyst-notes/',
      body: data,
    });
  }
  /**
   * Retrieve multiple analyst notes by their reference IDs and reference type.
   * POST /api/analyst-notes/bulk/
   * Returns a dictionary where keys are reference IDs (as strings) and values are note objects
   * in the same structure as returned by /dashboard/user/{id}/models/ endpoint.
   * @returns any
   * @throws ApiError
   */
  public static apiAnalystNotesBulkCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/analyst-notes/bulk/',
    });
  }
  /**
   * Retrieve or update an analyst note by note ID.
   * GET /api/analyst-notes/{note_id}/ - Retrieve
   * PUT /api/analyst-notes/{note_id}/ - Update
   * @param noteId
   * @returns any
   * @throws ApiError
   */
  public static apiAnalystNotesRead(
    noteId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/analyst-notes/{note_id}/',
      path: {
        'note_id': noteId,
      },
    });
  }
  /**
   * Retrieve or update an analyst note by note ID.
   * GET /api/analyst-notes/{note_id}/ - Retrieve
   * PUT /api/analyst-notes/{note_id}/ - Update
   * @param noteId
   * @returns any
   * @throws ApiError
   */
  public static apiAnalystNotesUpdate(
    noteId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/analyst-notes/{note_id}/',
      path: {
        'note_id': noteId,
      },
    });
  }
  /**
   * Retrieve or update an analyst note by note ID.
   * GET /api/analyst-notes/{note_id}/ - Retrieve
   * PUT /api/analyst-notes/{note_id}/ - Update
   * @param noteId
   * @returns any
   * @throws ApiError
   */
  public static apiAnalystNotesPartialUpdate(
    noteId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/analyst-notes/{note_id}/',
      path: {
        'note_id': noteId,
      },
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiAttioBulkConsultantsCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attio/bulk/consultants',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiAttioBulkDealsCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attio/bulk/deals',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiAttioBulkEngagementManagersCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attio/bulk/engagement-managers',
    });
  }
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiAttioBulkValuationsCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attio/bulk/valuations',
    });
  }
  /**
   * Get Attio API configuration for a specific endpoint.
   * @param endpoint
   * @returns any
   * @throws ApiError
   */
  public static apiAttioSettingsRead(
    endpoint: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attio/settings/{endpoint}',
      path: {
        'endpoint': endpoint,
      },
    });
  }
  /**
   * @param search Search query string
   * @returns any
   * @throws ApiError
   */
  public static apiAttioValuationsSearchList(
    search: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attio/valuations/search',
      query: {
        'search': search,
      },
    });
  }
  /**
   * Endpoint that fetches all valuations for a user and automatically loads
   * all related bulk data (consultants, managers, deals) and returns everything together.
   * @returns any
   * @throws ApiError
   */
  public static apiAttioValuationsWithBulkDataCreate(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attio/valuations/with-bulk-data',
    });
  }
  /**
   * Handle GET requests to Attio API.
   * @param endpoint
   * @returns any
   * @throws ApiError
   */
  public static apiAttioRead(
    endpoint: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attio/{endpoint}',
      path: {
        'endpoint': endpoint,
      },
    });
  }
  /**
   * Handle POST requests to Attio API.
   * @param endpoint
   * @returns any
   * @throws ApiError
   */
  public static apiAttioCreate(
    endpoint: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/attio/{endpoint}',
      path: {
        'endpoint': endpoint,
      },
    });
  }
  /**
   * Handle PATCH requests to Attio API.
   * Invalidates cache for the updated resource.
   * @param endpoint
   * @returns any
   * @throws ApiError
   */
  public static apiAttioPartialUpdate(
    endpoint: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/attio/{endpoint}',
      path: {
        'endpoint': endpoint,
      },
    });
  }
  /**
   * Retrieve and update a specific sheet attribute mapping by its ID.
   * GET returns nested structure constructed by the serializer.
   * PUT allows updating the mapping, including accepting AI-generated mappings.
   * @param id A unique integer value identifying this Sheet Attribute Mapping.
   * @returns any
   * @throws ApiError
   */
  public static apiAttributeMappingsRead(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/attribute-mappings/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Retrieve and update a specific sheet attribute mapping by its ID.
   * GET returns nested structure constructed by the serializer.
   * PUT allows updating the mapping, including accepting AI-generated mappings.
   * @param id A unique integer value identifying this Sheet Attribute Mapping.
   * @returns any
   * @throws ApiError
   */
  public static apiAttributeMappingsUpdate(
    id: number,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/attribute-mappings/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Update a mapping by its ID.
   * Uses the same serializer as financials saving (SheetAttributeMappingUpsertSerializer).
   * @param id A unique integer value identifying this Sheet Attribute Mapping.
   * @param data
   * @returns SheetAttributeMapping Mapping updated successfully
   * @throws ApiError
   */
  public static apiAttributeMappingsPartialUpdate(
    id: number,
    data: SheetAttributeMappingUpsert,
  ): CancelablePromise<SheetAttributeMapping> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/attribute-mappings/{id}',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Invalid request`,
        404: `Mapping not found`,
      },
    });
  }
  /**
   * Accept all AI-generated ordinates in a sheet attribute mapping
   * @param id
   * @returns SheetAttributeMapping All AI mappings accepted successfully
   * @throws ApiError
   */
  public static apiAttributeMappingsAcceptAllPartialUpdate(
    id: string,
  ): CancelablePromise<SheetAttributeMapping> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/attribute-mappings/{id}/accept-all',
      path: {
        'id': id,
      },
      errors: {
        400: `Mapping is not AI-generated`,
        404: `Mapping not found`,
      },
    });
  }
  /**
   * Decline (remove) all AI-generated ordinates in a sheet attribute mapping.
   * This removes all ordinates where is_ai_generated=True and is_accepted=False
   * from the grid_indicators (both columns and rows).
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static apiAttributeMappingsDeclineAllPartialUpdate(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/attribute-mappings/{id}/decline-all',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @returns void
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipDetailsDelete(
    id: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/cap-tables/fund-ownership-details/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param data
   * @returns ProFormaCapTableModel
   * @throws ApiError
   */
  public static apiCapTablesProFormaCreate(
    data: ProFormaCapTableModel,
  ): CancelablePromise<ProFormaCapTableModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cap-tables/pro-forma',
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesRead(
    id: number,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesUpdate(
    id: number,
    data: CapTableDetailsModel,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesPartialUpdate(
    id: number,
    data: CapTableDetailsModel,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesAllBreakpointsRead(
    id: number,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/all-breakpoints',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CustomBreakpoints
   * @throws ApiError
   */
  public static apiCapTablesAllBreakpointsUpdate(
    id: number,
    data: CustomBreakpoints,
  ): CancelablePromise<CustomBreakpoints> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/all-breakpoints',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Bad Request`,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesAllBreakpointsPartialUpdate(
    id: number,
    data: CapTableDetailsModel,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/all-breakpoints',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * GET /api/cap-tables/<pk>/cash-flow-ledger
   * Returns combined saved + virtualized cash flow items for the cap table, sorted by date ascending.
   * @param id
   * @returns CashFlowLedgerItem
   * @throws ApiError
   */
  public static apiCapTablesCashFlowLedgerList(
    id: string,
  ): CancelablePromise<CashFlowLedgerItem> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/cash-flow-ledger',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns any Successfully saved cash flow ledger items
   * @throws ApiError
   */
  public static apiCapTablesCashFlowLedgerBulkSaveCreate(
    id: string,
    data: CashFlowLedgerBulkSave,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/cap-tables/{id}/cash-flow-ledger/bulk-save',
      path: {
        'id': id,
      },
      body: data,
      errors: {
        400: `Validation error`,
        404: `Cap Table not found`,
      },
    });
  }
  /**
   * @param id
   * @returns any
   * @throws ApiError
   */
  public static apiCapTablesCheckAssociatedMeasurementDateList(
    id: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/check-associated-measurement-date',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this fund ownership.
   * @returns CapTableFundOwnership
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipRead(
    id: number,
  ): CancelablePromise<CapTableFundOwnership> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/fund-ownership',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id A unique integer value identifying this fund ownership.
   * @param data
   * @returns UpdateFundOwnershipResponse
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipUpdate(
    id: number,
    data: CapTableFundOwnership,
  ): CancelablePromise<UpdateFundOwnershipResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/fund-ownership',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this fund ownership.
   * @param data
   * @returns CapTableFundOwnership
   * @throws ApiError
   */
  public static apiCapTablesFundOwnershipPartialUpdate(
    id: number,
    data: CapTableFundOwnership,
  ): CancelablePromise<CapTableFundOwnership> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/fund-ownership',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @returns AllocationCompanyModel
   * @throws ApiError
   */
  public static apiCapTablesGotFinalAllocationRead(
    id: string,
  ): CancelablePromise<AllocationCompanyModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/got-final-allocation',
      path: {
        'id': id,
      },
    });
  }
  /**
   * Get gross IRR for a specific cap table and fund
   * Computes the gross IRR for the specified cap table and fund using the provided unrealized value at the given exit_date.
   * @param id A unique integer value identifying this cap table.
   * @param fund
   * @param unrealizedValue
   * @param exitDate
   * @returns CapTableGrossIRRResponse
   * @throws ApiError
   */
  public static apiCapTablesGrossIrrRead(
    id: number,
    fund: number,
    unrealizedValue: string,
    exitDate: string,
  ): CancelablePromise<CapTableGrossIRRResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/gross-irr',
      path: {
        'id': id,
      },
      query: {
        'fund': fund,
        'unrealized_value': unrealizedValue,
        'exit_date': exitDate,
      },
    });
  }
  /**
   * pk here is id of the company measurement date we're querying a primary captable for
   * @param id A unique integer value identifying this cap table.
   * @returns CapTableDetailsModel
   * @throws ApiError
   */
  public static apiCapTablesPrimaryRead(
    id: number,
  ): CancelablePromise<CapTableDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/cap-tables/{id}/primary',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns CapTableSecurities
   * @throws ApiError
   */
  public static apiCapTablesSecuritiesUpdate(
    id: string,
    data: CapTableSecurities,
  ): CancelablePromise<CapTableSecurities> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/securities',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns CapTableSecurities
   * @throws ApiError
   */
  public static apiCapTablesSecuritiesPartialUpdate(
    id: string,
    data: CapTableSecurities,
  ): CancelablePromise<CapTableSecurities> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/securities',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableModel
   * @throws ApiError
   */
  public static apiCapTablesToggleWaterfallVisibilityUpdate(
    id: number,
    data: CapTableModel,
  ): CancelablePromise<CapTableModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id A unique integer value identifying this cap table.
   * @param data
   * @returns CapTableModel
   * @throws ApiError
   */
  public static apiCapTablesToggleWaterfallVisibilityPartialUpdate(
    id: number,
    data: CapTableModel,
  ): CancelablePromise<CapTableModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param citationId
   * @returns void
   * @throws ApiError
   */
  public static apiCitationsDelete(
    citationId: string,
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/citations/{citation_id}/',
      path: {
        'citation_id': citationId,
      },
    });
  }
  /**
   * @param cmdId
   * @returns any
   * @throws ApiError
   */
  public static apiCompaniesFiscalEndDatesRead(
    cmdId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/companies/fiscal-end-dates/{cmd_id}',
      path: {
        'cmd_id': cmdId,
      },
    });
  }
  /**
   * Extract tables from specified PDF pages and return as Excel data.
   * Expected request data:
   * {
     * "page_numbers": [1, 2, 3]  # List of page numbers to process
     * }
     * @param companyId
     * @param fileId
     * @param data
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiCompaniesDocumentsConversionCreate(
      companyId: string,
      fileId: string,
      data: RetrieveDocumentGenerationJob,
    ): CancelablePromise<RetrieveDocumentGenerationJob> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/{company_id}/documents/{file_id}/conversion',
        path: {
          'company_id': companyId,
          'file_id': fileId,
        },
        body: data,
      });
    }
    /**
     * @param companyPk
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAllocationValuesRead(
      companyPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{company_pk}/allocation-values',
        path: {
          'company_pk': companyPk,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesRead(
      id: number,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesUpdate(
      id: number,
      data: Company,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesPartialUpdate(
      id: number,
      data: Company,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAllocationsList(
      id: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<AllocationName>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/allocations',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param fileType
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAssetSignedUrlRead(
      id: string,
      fileType: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/asset-signed-url/{file_type}',
        path: {
          'id': id,
          'file_type': fileType,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @param mp Measurement date ID
     * @param cmd Command ID for measurement date
     * @param includeConvertibleNotes Include convertible notes in the response
     * @returns CapTableName
     * @throws ApiError
     */
    public static apiCompaniesCapTablesList(
      id: string,
      page?: number,
      mp?: number,
      cmd?: number,
      includeConvertibleNotes: boolean = false,
    ): CancelablePromise<Array<CapTableName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/cap-tables',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'mp': mp,
          'cmd': cmd,
          'include_convertible_notes': includeConvertibleNotes,
        },
      });
    }
    /**
     * @param id
     * @param mdId
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesHasSummaryRead(
      id: string,
      mdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/has-summary/{md_id}',
        path: {
          'id': id,
          'md_id': mdId,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsInvestedCapitalRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/invested-capital',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsMoicRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/moic',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsUnrealizedValueRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/unrealized-value',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * Returns a list of investments for a company at a specific measurement date
     * @param id
     * @param mdId
     * @returns Investment A list of Investments
     * @throws ApiError
     */
    public static apiCompaniesSummaryRead(
      id: string,
      mdId: string,
    ): CancelablePromise<Array<Investment>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/summary/{md_id}',
        path: {
          'id': id,
          'md_id': mdId,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyQuestionSync
     * @throws ApiError
     */
    public static apiCompaniesSyncCompanyQuestionsUpdate(
      id: number,
      data: CompanyQuestionSync,
    ): CancelablePromise<CompanyQuestionSync> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}/sync-company-questions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyQuestionSync
     * @throws ApiError
     */
    public static apiCompaniesSyncCompanyQuestionsPartialUpdate(
      id: number,
      data: CompanyQuestionSync,
    ): CancelablePromise<CompanyQuestionSync> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}/sync-company-questions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * Retrieve a company measurement date by attio_valuation_id.
     * This is useful for finding the measurement date when we have the attio_valuation_id from query params.
     * If multiple records exist with the same attio_valuation_id, returns the most recent one.
     * @param attioValuationId Attio valuation ID
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesRead(
      attioValuationId: string,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/',
        query: {
          'attio_valuation_id': attioValuationId,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company measurement date.
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesRead1(
      id: number,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company measurement date.
     * @param data
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesUpdate(
      id: number,
      data: CompanyMeasurementDateModel,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/company-measurement-dates/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company measurement date.
     * @param data
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesPartialUpdate(
      id: number,
      data: CompanyMeasurementDateModel,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/company-measurement-dates/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param date
     * @returns MeasurementDateExistsReturn
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesExistsRead(
      id: string,
      date: string,
    ): CancelablePromise<MeasurementDateExistsReturn> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/{id}/exists/{date}/',
        path: {
          'id': id,
          'date': date,
        },
      });
    }
    /**
     * @param mdPk
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesByMeasurementDateRead(
      mdPk: string,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/{md_pk}/by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param companyId
     * @param search A search term.
     * @returns CustomPrimaryUser
     * @throws ApiError
     */
    public static apiCompanyUsersRead(
      companyId: string,
      search?: string,
    ): CancelablePromise<Array<CustomPrimaryUser>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-users/{company_id}',
        path: {
          'company_id': companyId,
        },
        query: {
          'search': search,
        },
      });
    }
    /**
     * @param companyId
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @returns any
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsList(
      companyId: string,
      page?: number,
      pageSize?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<RetrieveDocumentGenerationJob>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company/{company_id}/document-generation-jobs',
        path: {
          'company_id': companyId,
        },
        query: {
          'page': page,
          'page_size': pageSize,
        },
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsNewCreate(
      companyId: string,
      data: ApiCreateDocumentGenerationJob,
    ): CancelablePromise<RetrieveDocumentGenerationJob> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/company/{company_id}/document-generation-jobs/new',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param jobId
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsRead(
      companyId: string,
      jobId: string,
    ): CancelablePromise<RetrieveDocumentGenerationJob> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company/{company_id}/document-generation-jobs/{job_id}',
        path: {
          'company_id': companyId,
          'job_id': jobId,
        },
      });
    }
    /**
     * Get document execution sessions for a specific job, optionally creating File instances
     * @param companyId
     * @param jobId
     * @param page A page number within the paginated result set.
     * @param createFileReferences
     * @param measurementDateId
     * @param referenceObjectType
     * @returns RetrieveDocumentExecutionSession
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsDocumentExecutionSessionsList(
      companyId: string,
      jobId: string,
      page?: number,
      createFileReferences?: boolean,
      measurementDateId?: number,
      referenceObjectType: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' = 'ct',
    ): CancelablePromise<Array<RetrieveDocumentExecutionSession>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company/{company_id}/document-generation-jobs/{job_id}/document-execution-sessions',
        path: {
          'company_id': companyId,
          'job_id': jobId,
        },
        query: {
          'page': page,
          'create_file_references': createFileReferences,
          'measurement_date_id': measurementDateId,
          'reference_object_type': referenceObjectType,
        },
        errors: {
          404: `Job not found`,
        },
      });
    }
    /**
     * @param data
     * @returns InformationRequestStatus
     * @throws ApiError
     */
    public static apiCreateInformationRequestStatusCreate(
      data: InformationRequestStatus,
    ): CancelablePromise<InformationRequestStatus> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/create-information-request-status',
        body: data,
      });
    }
    /**
     * @param informationRequestStatusId
     * @param data
     * @returns TaskDetailedProgress
     * @throws ApiError
     */
    public static apiCreateInformationRequestUpdate(
      informationRequestStatusId: string,
      data: CreateDocumentAndQuestionnaireTasks,
    ): CancelablePromise<Array<TaskDetailedProgress>> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/create-information-request/{information_request_status_id}',
        path: {
          'information_request_status_id': informationRequestStatusId,
        },
        body: data,
      });
    }
    /**
     * @param informationRequestStatusId
     * @param data
     * @returns CreateDocumentAndQuestionnaireTasks
     * @throws ApiError
     */
    public static apiCreateInformationRequestPartialUpdate(
      informationRequestStatusId: string,
      data: CreateDocumentAndQuestionnaireTasks,
    ): CancelablePromise<CreateDocumentAndQuestionnaireTasks> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/create-information-request/{information_request_status_id}',
        path: {
          'information_request_status_id': informationRequestStatusId,
        },
        body: data,
      });
    }
    /**
     * @param data
     * @returns Create409Report
     * @throws ApiError
     */
    public static apiDashboardCreate(
      data: Create409Report,
    ): CancelablePromise<Create409Report> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard',
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns UpdateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionRead(
      questionId: string,
    ): CancelablePromise<UpdateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionUpdate(
      questionId: string,
      data: UpdateCompanyQuestion,
    ): CancelablePromise<UpdateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionPartialUpdate(
      questionId: string,
      data: UpdateCompanyQuestion,
    ): CancelablePromise<UpdateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionDelete(
      questionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param requestedDocumentId
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentRead(
      requestedDocumentId: string,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentUpdate(
      requestedDocumentId: string,
      data: CompanyRequestedDocumentModel,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentPartialUpdate(
      requestedDocumentId: string,
      data: CompanyRequestedDocumentModel,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentDelete(
      requestedDocumentId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param data
     * @returns AddBulkDashboardUser
     * @throws ApiError
     */
    public static apiDashboardCompanyAddBulkUserCreate(
      data: AddBulkDashboardUser,
    ): CancelablePromise<AddBulkDashboardUser> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/add-bulk-user/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns AddNewDashboardUser
     * @throws ApiError
     */
    public static apiDashboardCompanyAddUserCreate(
      data: AddNewDashboardUser,
    ): CancelablePromise<AddNewDashboardUser> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/add-user/',
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns UpdateScalarOpinionClientsAuthorized
     * @throws ApiError
     */
    public static apiDashboardCompanyApproveForClientsUpdate(
      cmdId: string,
      data: UpdateScalarOpinionClientsAuthorized,
    ): CancelablePromise<UpdateScalarOpinionClientsAuthorized> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/company/approve-for-clients/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns UpdateScalarOpinionClientsAuthorized
     * @throws ApiError
     */
    public static apiDashboardCompanyApproveForClientsPartialUpdate(
      cmdId: string,
      data: UpdateScalarOpinionClientsAuthorized,
    ): CancelablePromise<UpdateScalarOpinionClientsAuthorized> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/company/approve-for-clients/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param data
     * @returns NumberFriendlyCreateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompanyCreateQuestionsCreate(
      data: NumberFriendlyCreateCompanyQuestion,
    ): CancelablePromise<NumberFriendlyCreateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/create-questions/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompanyCreateRequestedDocumentsCreate(
      data: CompanyRequestedDocumentModel,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/create-requested-documents/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns AddOrRemoveRequestItems
     * @throws ApiError
     */
    public static apiDashboardCompanyModifyExistingRequestCreate(
      data: AddOrRemoveRequestItems,
    ): CancelablePromise<AddOrRemoveRequestItems> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/modify-existing-request/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns CompanyPrimaryContact
     * @throws ApiError
     */
    public static apiDashboardCompanyPrimaryContactCreate(
      data: CompanyPrimaryContact,
    ): CancelablePromise<CompanyPrimaryContact> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/primary-contact/',
        body: data,
      });
    }
    /**
     * @param companyId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardCompanyRead(
      companyId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<ScalarOpinionView>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}',
        path: {
          'company_id': companyId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns CreateCompanyInformationRequest
     * @throws ApiError
     */
    public static apiDashboardCompanyCreateInformationRequestCreate(
      companyId: string,
      data: CreateCompanyInformationRequest,
    ): CancelablePromise<CreateCompanyInformationRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/{company_id}/create-information-request/',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * Override list to return enhanced fulfillment data with user details
     * @param companyId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentList(
      companyId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<Fulfillment>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/',
        path: {
          'company_id': companyId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentCreate(
      companyId: string,
      data: Fulfillment,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentRead(
      companyId: string,
      attioValuationId: string,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @param data
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentUpdate(
      companyId: string,
      attioValuationId: string,
      data: Fulfillment,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @param data
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentPartialUpdate(
      companyId: string,
      attioValuationId: string,
      data: Fulfillment,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentDelete(
      companyId: string,
      attioValuationId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
      });
    }
    /**
     * @param companyId
     * @returns CompanyRequestedInformation
     * @throws ApiError
     */
    public static apiDashboardCompanyRequestedInformationRead(
      companyId: string,
    ): CancelablePromise<CompanyRequestedInformation> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}/requested-information',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @param cmdId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardCurrentInformationRequestsRead(
      cmdId: string,
      page?: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/current-information-requests/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardDownloadValuationReportRead(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/download-valuation-report/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardGpcCompsList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<GPCPeriods>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/gpc-comps',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns GPCPeriods
     * @throws ApiError
     */
    public static apiDashboardGpcCompsCreate(
      data: GPCPeriods,
    ): CancelablePromise<GPCPeriods> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/gpc-comps',
        body: data,
      });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardGpcCompsDelete(): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/gpc-comps',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardPublicCompaniesCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/public-companies',
      });
    }
    /**
     * Get all fulfillments where the specified users are reviewers or preparers across all companies,
     * or fulfillments with no assigned reviewers/preparers, for the Model Reviewer/Preparer Dashboard
     *
     * Request Body:
     * - preparer_ids: List of preparer user IDs (optional). Example: [1, 2, 3]
     * - reviewer_ids: List of reviewer user IDs (optional). Example: [1, 2, 3]
     * - status_filter: Filter by fulfillment status ('current', 'past', 'all', or 'unassigned')
     * - 'current': Returns fulfillments with status 0, 1, 2, 3, 4 (non-completed: Draft, Review, In-process ScalarUSA, Final, Review Final)
     * - 'past': Returns fulfillments with status 5 (completed: Complete only)
     * - 'unassigned': Returns fulfillments with no reviewers/preparers assigned
     * - 'all': Returns all fulfillments
     * - Default: 'all'
     * - from_date: Filter by fulfillment creation date (optional). Example: '2026-01-01' (YYYY-MM-DD)
     * - to_date: Filter by fulfillment creation date (optional). Example: '2026-01-31' (YYYY-MM-DD)
     * - company: Filter by company name (optional). Example: 'Microsoft'
     *
     * Returns fulfillments that either:
     * - Have any of the specified users as reviewers or preparers (when status_filter is 'current', 'past', or 'all'), OR
     * - Have no assigned reviewers and no assigned preparers (when status_filter is 'unassigned')
     * @param data
     * @returns UserFulfillmentRequest
     * @throws ApiError
     */
    public static apiDashboardUserModelsCreate(
      data: UserFulfillmentRequest,
    ): CancelablePromise<UserFulfillmentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/user/models/',
        body: data,
      });
    }
    /**
     * @param cmdId
     * @returns ValuationOpinionModule
     * @throws ApiError
     */
    public static apiDashboardRead(
      cmdId: string,
    ): CancelablePromise<ValuationOpinionModule> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns ValuationOpinionModule
     * @throws ApiError
     */
    public static apiDashboardUpdate(
      cmdId: string,
      data: ValuationOpinionModule,
    ): CancelablePromise<ValuationOpinionModule> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns ValuationOpinionModule
     * @throws ApiError
     */
    public static apiDashboardPartialUpdate(
      cmdId: string,
      data: ValuationOpinionModule,
    ): CancelablePromise<ValuationOpinionModule> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardGpcCompsRead(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/{cmd_id}/gpc-comps',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * Manually trigger document classification for a file
     * @param data
     * @returns AIClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationClassifyCreate(
      data: ClassifyDocument,
    ): CancelablePromise<AIClassification> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/classification/classify/',
        body: data,
        errors: {
          400: `Classification failed`,
          404: `File not found`,
        },
      });
    }
    /**
     * List all AI classifications for a specific file.
     * GET /api/documents/classification/file/<file_id>/
     * @param fileId
     * @returns AIClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationFileRead(
      fileId: string,
    ): CancelablePromise<Array<AIClassification>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/classification/file/{file_id}/',
        path: {
          'file_id': fileId,
        },
      });
    }
    /**
     * List all document references pending auto-classification approval.
     * GET /api/documents/classification/pending/
     * GET /api/documents/classification/pending/?md_id=<measurement_date_id>
     * @returns DocumentReferenceClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationPendingList(): CancelablePromise<Array<DocumentReferenceClassification>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/classification/pending/',
      });
    }
    /**
     * Approve a document's auto-classification suggestion
     * @param documentReferenceId
     * @param data
     * @returns DocumentReferenceClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationApproveCreate(
      documentReferenceId: string,
      data: ClassificationApproval,
    ): CancelablePromise<DocumentReferenceClassification> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/classification/{document_reference_id}/approve/',
        path: {
          'document_reference_id': documentReferenceId,
        },
        body: data,
        errors: {
          400: `Document not pending classification approval`,
          404: `Document reference not found`,
        },
      });
    }
    /**
     * Decline a document's auto-classification suggestion
     * @param documentReferenceId
     * @param data
     * @returns DocumentReferenceClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationDeclineCreate(
      documentReferenceId: string,
      data: ClassificationApproval,
    ): CancelablePromise<DocumentReferenceClassification> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/classification/{document_reference_id}/decline/',
        path: {
          'document_reference_id': documentReferenceId,
        },
        body: data,
        errors: {
          400: `Document not pending classification approval`,
          404: `Document reference not found`,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this measurement date documents.
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsCompanyRead(
      id: number,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<CompanyDocuments>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/company/{id}',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param mdId
     * @param data
     * @returns DocumentReferenceObjectView
     * @throws ApiError
     */
    public static apiDocumentsDocumentReferenceObjectsCreate(
      mdId: string,
      data: CreateOrDeleteDocumentReferenceObject,
    ): CancelablePromise<Array<DocumentReferenceObjectView>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/document-reference-objects/{md_id}',
        path: {
          'md_id': mdId,
        },
        body: data,
      });
    }
    /**
     * Download actual file content from S3 instead of returning a signed URL.
     * Supports both direct file download and base64-encoded response.
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsDownloadContentRead(
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/download-content/{file_id}',
        path: {
          'file_id': fileId,
        },
      });
    }
    /**
     * @param fileId
     * @param versionId Optional version ID of the file to download a specific version (not used since we are not retaining versions ids yet)
     * @param firmId Optional firm ID to specify the firm context for the file download. Used when downloading a firm summary report.
     * @returns any Presigned URL to download the file.
     * @throws ApiError
     */
    public static apiDocumentsDownloadRead(
      fileId: string,
      versionId?: string,
      firmId?: string,
    ): CancelablePromise<{
      signed_url?: string;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/download/{file_id}',
        path: {
          'file_id': fileId,
        },
        query: {
          'version_id': versionId,
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param mdId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFeatureObjectsRead(
      mdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/feature-objects/{md_id}',
        path: {
          'md_id': mdId,
        },
      });
    }
    /**
     * @param mdPk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFileUploadRequestRead(
      mdPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/file-upload-request/{md_pk}',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param mdPk
     * @param fileUuid
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFileUploadRequestRead1(
      mdPk: string,
      fileUuid: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/file-upload-request/{md_pk}/{file_uuid}',
        path: {
          'md_pk': mdPk,
          'file_uuid': fileUuid,
        },
      });
    }
    /**
     * @param mdPk
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsHasDocumentsRead(
      mdPk: string,
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/has-documents/{md_pk}/{company_id}',
        path: {
          'md_pk': mdPk,
          'company_id': companyId,
        },
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsReferenceCreate(
      mdId: string,
      filePk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/reference/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsReferenceDelete(
      mdId: string,
      filePk: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/reference/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsReferenceObjectCreate(
      mdId: string,
      filePk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/reference_object/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsReferenceObjectDelete(
      mdId: string,
      filePk: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/reference_object/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
      });
    }
    /**
     * @param documentReferenceId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsReferencesRead(
      documentReferenceId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/references/{document_reference_id}',
        path: {
          'document_reference_id': documentReferenceId,
        },
      });
    }
    /**
     * @param data
     * @returns DocumentRequestView
     * @throws ApiError
     */
    public static apiDocumentsRequestCreate(
      data: DocumentRequestView,
    ): CancelablePromise<DocumentRequestView> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/request',
        body: data,
      });
    }
    /**
     * @param data
     * @returns IndividualRequestedFile
     * @throws ApiError
     */
    public static apiDocumentsRequestedFileCreate(
      data: IndividualRequestedFile,
    ): CancelablePromise<IndividualRequestedFile> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requested-file',
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this requested file.
     * @param data
     * @returns IndividualRequestedFile
     * @throws ApiError
     */
    public static apiDocumentsRequestedFileUpdate(
      id: number,
      data: IndividualRequestedFile,
    ): CancelablePromise<IndividualRequestedFile> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this requested file.
     * @param data
     * @returns IndividualRequestedFile
     * @throws ApiError
     */
    public static apiDocumentsRequestedFilePartialUpdate(
      id: number,
      data: IndividualRequestedFile,
    ): CancelablePromise<IndividualRequestedFile> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this requested file.
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsRequestedFileDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/requested-file/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * After each successful upload (to bucket) we hit this endpoint to create File and DocumentReference objects,
     * to update the RequestedFile status, and check if the entire task is done.
     * @param documentRequestId
     * @param hmacToken
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsFileUploadStatusCreate(
      documentRequestId: string,
      hmacToken: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/file-upload-status/{document_request_id}/{hmac_token}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
      });
    }
    /**
     * Return current delegation status for the document request.
     * @param taskId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskAdminDelegateList(
      taskId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<AdminDelegateDocumentRequest>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/requests/task/{task_id}/admin-delegate',
        path: {
          'task_id': taskId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * Admin-level delegation endpoint.
     * @param taskId
     * @param data
     * @returns AdminDelegateDocumentRequest
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskAdminDelegateCreate(
      taskId: string,
      data: AdminDelegateDocumentRequest,
    ): CancelablePromise<AdminDelegateDocumentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/task/{task_id}/admin-delegate',
        path: {
          'task_id': taskId,
        },
        body: data,
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsValidateTokenRead(
      documentRequestId: string,
      hmacToken: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/requests/validate-token/{document_request_id}/{hmac_token}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
      });
    }
    /**
     * Allows a portal user to delegate their document request to another person.
     * No login required - uses HMAC token authentication.
     * @param documentRequestId
     * @param hmacToken
     * @param data
     * @returns DelegateDocumentRequest
     * @throws ApiError
     */
    public static apiDocumentsRequestsDelegateCreate(
      documentRequestId: string,
      hmacToken: string,
      data: DelegateDocumentRequest,
    ): CancelablePromise<DelegateDocumentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/delegate',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
        body: data,
      });
    }
    /**
     * Allows a portal user to re-delegate (reassign) an existing delegation to a different person.
     * This soft-deletes the old delegation and all its descendants, then creates a new delegation.
     * No login required - uses HMAC token authentication.
     * @param documentRequestId
     * @param hmacToken
     * @param data
     * @returns RedelegateDocumentRequest
     * @throws ApiError
     */
    public static apiDocumentsRequestsRedelegateCreate(
      documentRequestId: string,
      hmacToken: string,
      data: RedelegateDocumentRequest,
    ): CancelablePromise<RedelegateDocumentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/redelegate',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
        body: data,
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @param mdPk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsSignedUrlRead(
      documentRequestId: string,
      hmacToken: string,
      mdPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/signed-url/{md_pk}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @param taskId
     * @param data
     * @returns TaskModel
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskStatusUpdate(
      documentRequestId: string,
      hmacToken: string,
      taskId: string,
      data: TaskModel,
    ): CancelablePromise<TaskModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
          'task_id': taskId,
        },
        body: data,
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @param taskId
     * @param data
     * @returns TaskModel
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskStatusPartialUpdate(
      documentRequestId: string,
      hmacToken: string,
      taskId: string,
      data: TaskModel,
    ): CancelablePromise<TaskModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
          'task_id': taskId,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this file.
     * @param data
     * @returns FileUpdateRequestedFiles
     * @throws ApiError
     */
    public static apiDocumentsUpdateRequestedFileUpdate(
      id: number,
      data: FileUpdateRequestedFiles,
    ): CancelablePromise<FileUpdateRequestedFiles> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/update-requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this file.
     * @param data
     * @returns FileUpdateRequestedFiles
     * @throws ApiError
     */
    public static apiDocumentsUpdateRequestedFilePartialUpdate(
      id: number,
      data: FileUpdateRequestedFiles,
    ): CancelablePromise<FileUpdateRequestedFiles> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/update-requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsAddToFolderCreate(
      docsId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/{docs_id}/add-to-folder',
        path: {
          'docs_id': docsId,
        },
      });
    }
    /**
     * @param docsId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesCreate(
      docsId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/{docs_id}/files',
        path: {
          'docs_id': docsId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesRead(
      docsId: string,
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesUpdate(
      docsId: string,
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesPartialUpdate(
      docsId: string,
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsFilesDelete(
      docsId: string,
      fileId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesVersionsRead(
      docsId: string,
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{docs_id}/files/{file_id}/versions',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFolderCreate(
      docsId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/{docs_id}/folder',
        path: {
          'docs_id': docsId,
        },
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @returns FolderView
     * @throws ApiError
     */
    public static apiDocumentsFolderRead(
      docsId: string,
      folderId: string,
    ): CancelablePromise<FolderView> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @param data
     * @returns FolderModel
     * @throws ApiError
     */
    public static apiDocumentsFolderUpdate(
      docsId: string,
      folderId: string,
      data: FolderModel,
    ): CancelablePromise<FolderModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @param data
     * @returns FolderView
     * @throws ApiError
     */
    public static apiDocumentsFolderPartialUpdate(
      docsId: string,
      folderId: string,
      data: FolderView,
    ): CancelablePromise<FolderView> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsFolderDelete(
      docsId: string,
      folderId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
      });
    }
    /**
     * @param mdId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsReferencesRead1(
      mdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{md_id}/references',
        path: {
          'md_id': mdId,
        },
      });
    }
    /**
     * @param mdPk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRead(
      mdPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{md_pk}',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * Retrieve full company reports information for a specific date and firm independently of their status.
     * @param firmId
     * @param page A page number within the paginated result set.
     * @param date The date (YYYY-MM-DD) for which to retrieve or generate full company reports.
     * @returns ExcelExportExtendedModel
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsByDateList(
      firmId: string,
      page?: number,
      date?: string,
    ): CancelablePromise<Array<ExcelExportExtendedModel>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports-by-date',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
          'date': date,
        },
      });
    }
    /**
     * Enqueue full company reports generation for the specified company measurement dates.
     * Request body indicates which reports could be enqueued based on the flags for statuses.
     * @param firmId
     * @param data
     * @param date The date (YYYY-MM-DD) for which to retrieve or generate full company reports.
     * @returns ExcelExportStartInputData
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsByDateCreate(
      firmId: string,
      data: ExcelExportStartInputData,
      date?: string,
    ): CancelablePromise<ExcelExportStartInputData> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/excel-exports/{firm_id}/full-company-reports-by-date',
        path: {
          'firm_id': firmId,
        },
        query: {
          'date': date,
        },
        body: data,
      });
    }
    /**
     * Retrieve all full company reports for a firm, regardless of their status.
     * @param firmId
     * @param date
     * @returns AutoUpdatedFirmReportZipModel
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsAllReportsRead(
      firmId: string,
      date: string,
    ): CancelablePromise<AutoUpdatedFirmReportZipModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports/all-reports/{date}',
        path: {
          'firm_id': firmId,
          'date': date,
        },
        errors: {
          404: `No reports found for the specified date.`,
        },
      });
    }
    /**
     * Generates a signed url for the auto updated firm zip to return it to client app
     * @param firmId
     * @param date
     * @returns any The signed url for the firm zip
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsAllReportsSignedUrlRead(
      firmId: string,
      date: string,
    ): CancelablePromise<{
      /**
       * The signed url
       */
      signed_url?: string;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports/all-reports/{date}/signed_url',
        path: {
          'firm_id': firmId,
          'date': date,
        },
      });
    }
    /**
     * Retrieve or generate full company reports for the specified company measurement dates in a single zip file.
     * @param firmId
     * @param data
     * @returns any A job ID indicating that all reports are ready for download.
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsDownloadJobCreate(
      firmId: string,
      data: ExcelExportsRequested,
    ): CancelablePromise<{
      /**
       * A unique job identifier.
       */
      job_id?: string;
    }> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/excel-exports/{firm_id}/full-company-reports/download-job',
        path: {
          'firm_id': firmId,
        },
        body: data,
        errors: {
          409: `Indicates that some reports need to be generated.`,
        },
      });
    }
    /**
     * Check the status of download job
     * @param firmId
     * @param jobId
     * @returns JobStatusResponse Zip is available
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsDownloadJobRead(
      firmId: string,
      jobId: string,
    ): CancelablePromise<JobStatusResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports/download-job/{job_id}',
        path: {
          'firm_id': firmId,
          'job_id': jobId,
        },
        errors: {
          404: `Job not found.`,
        },
      });
    }
    /**
     * @param fileId
     * @param inspect When true, process the XLSX if needed and return a signed URL. When false or omitted, only poll for existing processed output.
     * @returns PresignedURL
     * @throws ApiError
     */
    public static apiFilesProcessedRead(
      fileId: string,
      inspect: boolean = false,
    ): CancelablePromise<PresignedURL> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/files/{file_id}/processed',
        path: {
          'file_id': fileId,
        },
        query: {
          'inspect': inspect,
        },
      });
    }
    /**
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreate(
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/financials/financial_page/',
        body: data,
      });
    }
    /**
     * @param cmdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialRfydRead(
      cmdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{cmd_pk}/financial_rfyd/',
        path: {
          'cmd_pk': cmdPk,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @returns FinancialStatementFullRead
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageRead(
      id: number,
    ): CancelablePromise<FinancialStatementFullRead> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreate1(
      id: number,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageUpdate(
      id: number,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPagePartialUpdate(
      id: number,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @returns void
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullRead
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreateVersionCreate(
      id: number,
      data: FinancialStatementVersionValidator,
    ): CancelablePromise<FinancialStatementFullRead> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/financials/financial_page/{id}/create_version/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param mdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialLtmNtmRead(
      mdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/financial_ltm_ntm/',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param mdPk
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialsBasicDataListList(
      mdPk: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FinancialStatementBasicData>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/financials_basic_data_list/',
        path: {
          'md_pk': mdPk,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param mdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDateRead(
      mdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param mdPk
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDateUpdate(
      mdPk: string,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
        body: data,
      });
    }
    /**
     * @param mdPk
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDatePartialUpdate(
      mdPk: string,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
        body: data,
      });
    }
    /**
     * @param mdPk
     * @param page A page number within the paginated result set.
     * @returns FinancialStatementSmall
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageListByMeasurementPeriodList(
      mdPk: string,
      page?: number,
    ): CancelablePromise<Array<FinancialStatementSmall>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/list_by_measurement_period/',
        path: {
          'md_pk': mdPk,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FirmUserPermission>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns FirmCompany
     * @throws ApiError
     */
    public static apiFirmsCompaniesNewCreate(
      data: FirmCompany,
    ): CancelablePromise<FirmCompany> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/companies/new',
        body: data,
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsCreateFirmQuestionCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/create-firm-question',
      });
    }
    /**
     * @param data
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsCreateFirmRequestedDocumentCreate(
      data: FirmRequestedDocumentModel,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/create-firm-requested-document',
        body: data,
      });
    }
    /**
     * @param data
     * @returns CreateFirmRequests
     * @throws ApiError
     */
    public static apiFirmsCreateRequestsCreate(
      data: CreateFirmRequests,
    ): CancelablePromise<CreateFirmRequests> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/create-requests',
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentRead(
      requestedDocumentId: string,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentUpdate(
      requestedDocumentId: string,
      data: FirmRequestedDocumentModel,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentPartialUpdate(
      requestedDocumentId: string,
      data: FirmRequestedDocumentModel,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentDelete(
      requestedDocumentId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param data
     * @returns FirmStepper
     * @throws ApiError
     */
    public static apiFirmsNewCreate(
      data: FirmStepper,
    ): CancelablePromise<FirmStepper> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/new',
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns UpdateFirmQuestion
     * @throws ApiError
     */
    public static apiFirmsQuestionRead(
      questionId: string,
    ): CancelablePromise<UpdateFirmQuestion> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateFirmQuestion
     * @throws ApiError
     */
    public static apiFirmsQuestionUpdate(
      questionId: string,
      data: UpdateFirmQuestion,
    ): CancelablePromise<UpdateFirmQuestion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateFirmQuestion
     * @throws ApiError
     */
    public static apiFirmsQuestionPartialUpdate(
      questionId: string,
      data: UpdateFirmQuestion,
    ): CancelablePromise<UpdateFirmQuestion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsQuestionDelete(
      questionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param firmId
     * @param fileType
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsAssetSignedUrlRead(
      firmId: string,
      fileType: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/asset-signed-url/{file_type}',
        path: {
          'firm_id': firmId,
          'file_type': fileType,
        },
      });
    }
    /**
     * @param firmId
     * @param companyId
     * @returns InvestmentCompanyInfo
     * @throws ApiError
     */
    public static apiFirmsFundInvestmentRead(
      firmId: string,
      companyId: string,
    ): CancelablePromise<InvestmentCompanyInfo> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/fund-investment/{company_id}',
        path: {
          'firm_id': firmId,
          'company_id': companyId,
        },
      });
    }
    /**
     * @param firmId
     * @returns FirmRequestsView
     * @throws ApiError
     */
    public static apiFirmsQuestionsAndRequestedDocumentsRead(
      firmId: string,
    ): CancelablePromise<FirmRequestsView> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/questions-and-requested-documents',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param firmId
     * @returns FirmCompaniesRequestsProgress
     * @throws ApiError
     */
    public static apiFirmsRequestsProgressRead(
      firmId: string,
    ): CancelablePromise<FirmCompaniesRequestsProgress> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/requests-progress',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param firmPk
     * @param page A page number within the paginated result set.
     * @returns CompaniesByFirm A list of CompaniesByFirm objects
     * @throws ApiError
     */
    public static apiFirmsCompaniesListList(
      firmPk: string,
      page?: number,
    ): CancelablePromise<Array<CompaniesByFirm>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_pk}/companies-list/',
        path: {
          'firm_pk': firmPk,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersUpdate(
      firmPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_pk}/users',
        path: {
          'firm_pk': firmPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersPartialUpdate(
      firmPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{firm_pk}/users',
        path: {
          'firm_pk': firmPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersUpdate1(
      firmPk: string,
      userPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_pk}/users/{user_pk}',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersPartialUpdate1(
      firmPk: string,
      userPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{firm_pk}/users/{user_pk}',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsUsersDelete(
      firmPk: string,
      userPk: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/{firm_pk}/users/{user_pk}',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns UserFirmRole
     * @throws ApiError
     */
    public static apiFirmsUsersRolesUpdate(
      firmPk: string,
      userPk: string,
      data: UserFirmRole,
    ): CancelablePromise<UserFirmRole> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns UserFirmRole
     * @throws ApiError
     */
    public static apiFirmsUsersRolesPartialUpdate(
      firmPk: string,
      userPk: string,
      data: UserFirmRole,
    ): CancelablePromise<UserFirmRole> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this firm.
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsRead(
      id: number,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this firm.
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUpdate(
      id: number,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this firm.
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsPartialUpdate(
      id: number,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsCompaniesList(
      id: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<CompanyWithMeasurementDates>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/companies',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param cId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsCompanyRead(
      id: string,
      cId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<ExtendedCompanyInfo>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/company/{c_id}',
        path: {
          'id': id,
          'c_id': cId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this fund.
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsFundsList(
      id: number,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FundName>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/funds',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsHasSummaryRead(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/has-summary',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns any Indicates if the firm has summary data
     * @throws ApiError
     */
    public static apiFirmsHasSummaryCreate(
      id: string,
      data: FundByMeasurementDate,
    ): CancelablePromise<{
      has_summary?: boolean;
    }> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{id}/has-summary',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format
     * @param fundId Optional fund ID filter
     * @returns FirmSummaryRead
     * @throws ApiError
     */
    public static apiFirmsSummaryRead(
      id: string,
      date?: string,
      fundId?: number,
    ): CancelablePromise<FirmSummaryRead> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/summary',
        path: {
          'id': id,
        },
        query: {
          'date': date,
          'fund_id': fundId,
        },
        errors: {
          400: `Invalid date format`,
        },
      });
    }
    /**
     * @param allocationId
     * @returns any
     * @throws ApiError
     */
    public static apiFundInvestmentsRead(
      allocationId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/fund-investments/{allocation_id}/',
        path: {
          'allocation_id': allocationId,
        },
      });
    }
    /**
     * @param allocationId
     * @returns any
     * @throws ApiError
     */
    public static apiFundInvestmentsCreate(
      allocationId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/fund-investments/{allocation_id}/',
        path: {
          'allocation_id': allocationId,
        },
      });
    }
    /**
     * @param companyId
     * @param measurementDateId
     * @returns AvailableAllocation
     * @throws ApiError
     */
    public static apiFundInvestmentsExportDataAvailabilityRead(
      companyId: string,
      measurementDateId: string,
    ): CancelablePromise<Array<AvailableAllocation>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/fund-investments/{company_id}/export-data-availability/{measurement_date_id}/',
        path: {
          'company_id': companyId,
          'measurement_date_id': measurementDateId,
        },
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFundsList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<Fund>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsCreate(
      data: Fund,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/funds',
        body: data,
      });
    }
    /**
     * @param fuId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFundsCompaniesList(
      fuId: string,
      page?: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{fu_id}/companies/',
        path: {
          'fu_id': fuId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsRead(
      id: string,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsUpdate(
      id: string,
      data: Fund,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsPartialUpdate(
      id: string,
      data: Fund,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiFundsDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @param date Optional date filter in YYYY-MM-DD format (if not provided returns most recent data)
     * @returns AllocationConclusionModel A list of Fund Allocation Summaries
     * @throws ApiError
     */
    public static apiFundsAllocationsList(
      id: string,
      page?: number,
      date?: string,
    ): CancelablePromise<Array<AllocationConclusionModel>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/allocations',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'date': date,
        },
        errors: {
          400: `Invalid date format`,
        },
      });
    }
    /**
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format (if not provided returns most recent data)
     * @returns Investment A list of Investments
     * @throws ApiError
     */
    public static apiFundsInvestmentsRead(
      id: string,
      date?: string,
    ): CancelablePromise<Array<Investment>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/investments',
        path: {
          'id': id,
        },
        query: {
          'date': date,
        },
      });
    }
    /**
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format (if not provided returns most recent data)
     * @returns FundSummary A Fund Summary
     * @throws ApiError
     */
    public static apiFundsSummaryRead(
      id: string,
      date?: string,
    ): CancelablePromise<FundSummary> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/summary',
        path: {
          'id': id,
        },
        query: {
          'date': date,
        },
        errors: {
          400: `Invalid date format`,
        },
      });
    }
    /**
     * Create a mapping from generation job results.
     * Expected request body:
     * {
       * "document_reference_id": 123,  // optional - reads from job metadata if not provided
       * "sheet_name": "Balance Sheet"  // optional
       * }
       *
       * For FINANCIAL_MAPPING jobs with metadata, this will also associate the mapping
       * with the financial statement.
       * @param jobId
       * @param data
       * @returns SheetAttributeMapping Mapping created successfully
       * @throws ApiError
       */
      public static apiGenerationJobsAttributeMappingsCreate(
        jobId: string,
        data: {
          /**
           * ID of the document reference to associate with this mapping. If not provided, reads from job metadata.
           */
          document_reference_id?: number;
          /**
           * Optional sheet name to process. If not provided, uses first sheet.
           */
          sheet_name?: string;
        },
      ): CancelablePromise<SheetAttributeMapping> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/generation-jobs/{job_id}/attribute-mappings',
          path: {
            'job_id': jobId,
          },
          body: data,
          errors: {
            400: `Bad request - invalid input or job not found`,
            500: `Server error during transformation`,
          },
        });
      }
      /**
       * @param data
       * @returns UpdateIndividualQuestion
       * @throws ApiError
       */
      public static apiIndividualQuestionsCreate(
        data: UpdateIndividualQuestion,
      ): CancelablePromise<UpdateIndividualQuestion> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/individual-questions/',
          body: data,
        });
      }
      /**
       * @param id A unique integer value identifying this individual question.
       * @param data
       * @returns UpdateIndividualQuestion
       * @throws ApiError
       */
      public static apiIndividualQuestionsUpdate(
        id: number,
        data: UpdateIndividualQuestion,
      ): CancelablePromise<UpdateIndividualQuestion> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/individual-questions/{id}',
          path: {
            'id': id,
          },
          body: data,
        });
      }
      /**
       * @param id A unique integer value identifying this individual question.
       * @param data
       * @returns UpdateIndividualQuestion
       * @throws ApiError
       */
      public static apiIndividualQuestionsPartialUpdate(
        id: number,
        data: UpdateIndividualQuestion,
      ): CancelablePromise<UpdateIndividualQuestion> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/individual-questions/{id}',
          path: {
            'id': id,
          },
          body: data,
        });
      }
      /**
       * @param id A unique integer value identifying this individual question.
       * @returns void
       * @throws ApiError
       */
      public static apiIndividualQuestionsDelete(
        id: number,
      ): CancelablePromise<void> {
        return __request(OpenAPI, {
          method: 'DELETE',
          url: '/api/individual-questions/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * Check if an excel report exists and retrieve its metadata.
       * @param reportUuid
       * @param data
       * @returns FileModel
       * @throws ApiError
       */
      public static apiInvestorAppCheckExcelReportCreate(
        reportUuid: string,
        data: {
          /**
           * ID of the firm related to the report. Optional.
           */
          firm?: number;
        },
      ): CancelablePromise<FileModel> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/investor-app/check-excel-report/{reportUUID}',
          path: {
            'reportUUID': reportUuid,
          },
          body: data,
          errors: {
            404: `Report not found.`,
          },
        });
      }
      /**
       * @param reportUuid
       * @returns any
       * @throws ApiError
       */
      public static apiInvestorAppExcelReportCreate(
        reportUuid: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/investor-app/excel-report/{reportUUID}',
          path: {
            'reportUUID': reportUuid,
          },
        });
      }
      /**
       * This APIView is used to get all of the companymeasurement dates for a firm.
       * @param firmId
       * @returns CompanyMeasurementDateName
       * @throws ApiError
       */
      public static apiMeasurementDatesAllCompaniesByFirmRead(
        firmId: string,
      ): CancelablePromise<Array<CompanyMeasurementDateName>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/measurement-dates/all-companies-by-firm/{firm_id}/',
          path: {
            'firm_id': firmId,
          },
        });
      }
      /**
       * This APIView is used to get all of the measurement dates for a firm.
       * @param firmId
       * @returns FundMeasurementDateName
       * @throws ApiError
       */
      public static apiMeasurementDatesAllFundsByFirmRead(
        firmId: string,
      ): CancelablePromise<Array<FundMeasurementDateName>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/measurement-dates/all-funds-by-firm/{firm_id}/',
          path: {
            'firm_id': firmId,
          },
        });
      }
      /**
       * This APIView is used to get the measurement dates for a firm. It will return all the measurement dates
       * excluding the repeated ones, in other words the measurement dates with the same dates but for diferent
       * companies and funds, will be "merged" into one.
       * @param firmId
       * @returns MeasurementDateName
       * @throws ApiError
       */
      public static apiMeasurementDatesByFirmRead(
        firmId: string,
      ): CancelablePromise<Array<MeasurementDateName>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/measurement-dates/by-firm/{firm_id}',
          path: {
            'firm_id': firmId,
          },
        });
      }
      /**
       * @param data
       * @returns MeasurementDateRolloverReturn Success
       * @throws ApiError
       */
      public static apiMeasurementDatesCompanyRolloverCreate(
        data: MeasurementDateRollover,
      ): CancelablePromise<MeasurementDateRolloverReturn> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/measurement-dates/company/rollover',
          body: data,
        });
      }
      /**
       * @param companyId
       * @returns MeasurementDateName
       * @throws ApiError
       */
      public static apiMeasurementDatesCompanyRead(
        companyId: string,
      ): CancelablePromise<Array<MeasurementDateName>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/measurement-dates/company/{company_id}',
          path: {
            'company_id': companyId,
          },
        });
      }
      /**
       * Concrete view for bulk delete Company/Fund measurement dates and all their related info.
       * @param data
       * @returns MeasurementDateExtended
       * @throws ApiError
       */
      public static apiMeasurementDatesDeleteRelatedInfoCreate(
        data: MeasurementDateExtended,
      ): CancelablePromise<MeasurementDateExtended> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/measurement-dates/delete-related-info',
          body: data,
        });
      }
      /**
       * @param firmId
       * @returns MeasurementDateName
       * @throws ApiError
       */
      public static apiMeasurementDatesFirmRead(
        firmId: string,
      ): CancelablePromise<Array<MeasurementDateName>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/measurement-dates/firm/{firm_id}',
          path: {
            'firm_id': firmId,
          },
        });
      }
      /**
       * This APIView is used to get the company/fund measurement dates from
       * measurement dates with the same date and firm, we merge the info into
       * one dictionary as a virtual "Measurement Date" and then we return it through
       * the serializer.
       * @param firmId
       * @param date
       * @returns any
       * @throws ApiError
       */
      public static apiMeasurementDatesFirmDateRead(
        firmId: string,
        date: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/measurement-dates/firm/{firm_id}/date/{date}',
          path: {
            'firm_id': firmId,
            'date': date,
          },
        });
      }
      /**
       * @param fundId
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiMeasurementDatesFundsRead(
        fundId: string,
        page?: number,
      ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<CompanyMeasurementDateNameNullable>;
      }> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/measurement-dates/funds/{fund_id}',
          path: {
            'fund_id': fundId,
          },
          query: {
            'page': page,
          },
        });
      }
      /**
       * Concrete view for bulk saving Note instances.
       * @param pageType
       * @param capTable
       * @param fundOwnership
       * @param financialStatement
       * @param fundMeasurementDate
       * @param allocation
       * @param valuationApproach
       * @param valuationApproachValuation
       * @param companyMeasurementDate
       * @param marketAdjustment
       * @param fundInvestmentOwnership
       * @returns any
       * @throws ApiError
       */
      public static apiNotesList(
        pageType?: string,
        capTable?: string,
        fundOwnership?: string,
        financialStatement?: string,
        fundMeasurementDate?: string,
        allocation?: string,
        valuationApproach?: string,
        valuationApproachValuation?: string,
        companyMeasurementDate?: string,
        marketAdjustment?: string,
        fundInvestmentOwnership?: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/notes/',
          query: {
            'page_type': pageType,
            'cap_table': capTable,
            'fund_ownership': fundOwnership,
            'financial_statement': financialStatement,
            'fund_measurement_date': fundMeasurementDate,
            'allocation': allocation,
            'valuation_approach': valuationApproach,
            'valuation_approach__valuation': valuationApproachValuation,
            'company_measurement_date': companyMeasurementDate,
            'market_adjustment': marketAdjustment,
            'fund_investment_ownership': fundInvestmentOwnership,
          },
        });
      }
      /**
       * Concrete view for bulk saving Note instances.
       * @param data
       * @returns Note
       * @throws ApiError
       */
      public static apiNotesCreate(
        data: Array<Note>,
      ): CancelablePromise<Array<Note>> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/notes/',
          body: data,
        });
      }
      /**
       * Concrete view for bulk saving Note instances.
       * @param pageType
       * @param capTable
       * @param fundOwnership
       * @param financialStatement
       * @param fundMeasurementDate
       * @param allocation
       * @param valuationApproach
       * @param valuationApproachValuation
       * @param companyMeasurementDate
       * @param marketAdjustment
       * @param fundInvestmentOwnership
       * @returns any
       * @throws ApiError
       */
      public static apiNotesListList(
        pageType?: string,
        capTable?: string,
        fundOwnership?: string,
        financialStatement?: string,
        fundMeasurementDate?: string,
        allocation?: string,
        valuationApproach?: string,
        valuationApproachValuation?: string,
        companyMeasurementDate?: string,
        marketAdjustment?: string,
        fundInvestmentOwnership?: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/notes/list',
          query: {
            'page_type': pageType,
            'cap_table': capTable,
            'fund_ownership': fundOwnership,
            'financial_statement': financialStatement,
            'fund_measurement_date': fundMeasurementDate,
            'allocation': allocation,
            'valuation_approach': valuationApproach,
            'valuation_approach__valuation': valuationApproachValuation,
            'company_measurement_date': companyMeasurementDate,
            'market_adjustment': marketAdjustment,
            'fund_investment_ownership': fundInvestmentOwnership,
          },
        });
      }
      /**
       * Concrete view for bulk saving Note instances.
       * @param data
       * @returns Note
       * @throws ApiError
       */
      public static apiNotesListCreate(
        data: Array<Note>,
      ): CancelablePromise<Array<Note>> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/notes/list',
          body: data,
        });
      }
      /**
       * Concrete view for retrieving Note instances.
       * @param id A unique integer value identifying this note.
       * @returns NoteGet
       * @throws ApiError
       */
      public static apiNotesRead(
        id: number,
      ): CancelablePromise<NoteGet> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/notes/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiOauth2SocialCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/oauth2/social/',
        });
      }
      /**
       * @param maturity
       * @param mdDate
       * @returns number A floating point value
       * @throws ApiError
       */
      public static apiObservationsRead(
        maturity: string,
        mdDate: string,
      ): CancelablePromise<number> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/observations/{maturity}/{md_date}',
          path: {
            'maturity': maturity,
            'md_date': mdDate,
          },
        });
      }
      /**
       * @param firmId
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiPendingDecisionsRead(
        firmId: string,
        page?: number,
      ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<UpdateDecisionsView>;
      }> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/pending-decisions/{firm_id}',
          path: {
            'firm_id': firmId,
          },
          query: {
            'page': page,
          },
        });
      }
      /**
       * @param firmId
       * @param data
       * @returns UpdateDecisionsView
       * @throws ApiError
       */
      public static apiPendingDecisionsCreate(
        firmId: string,
        data: UpdateDecisionsView,
      ): CancelablePromise<UpdateDecisionsView> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/pending-decisions/{firm_id}',
          path: {
            'firm_id': firmId,
          },
          body: data,
        });
      }
      /**
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiProfilesList(
        page?: number,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/profiles',
          query: {
            'page': page,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiProfilesCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/profiles',
        });
      }
      /**
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiProfilesMe(
        page?: number,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/profiles/me',
          query: {
            'page': page,
          },
        });
      }
      /**
       * @param id
       * @returns any
       * @throws ApiError
       */
      public static apiProfilesRead(
        id: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/profiles/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @returns any
       * @throws ApiError
       */
      public static apiProfilesUpdate(
        id: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/profiles/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @returns any
       * @throws ApiError
       */
      public static apiProfilesPartialUpdate(
        id: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/profiles/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @returns void
       * @throws ApiError
       */
      public static apiProfilesDelete(
        id: string,
      ): CancelablePromise<void> {
        return __request(OpenAPI, {
          method: 'DELETE',
          url: '/api/profiles/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @returns ChoiceAnswerModel
       * @throws ApiError
       */
      public static apiQuestionnairesChoicesForDropdownsList(): CancelablePromise<Array<ChoiceAnswerModel>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/questionnaires/choices-for-dropdowns/',
        });
      }
      /**
       * @param questionnaireId
       * @param hmacToken
       * @returns any
       * @throws ApiError
       */
      public static apiQuestionnairesRequestsValidateTokenRead(
        questionnaireId: string,
        hmacToken: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/questionnaires/requests/validate-token/{questionnaire_id}/{hmac_token}',
          path: {
            'questionnaire_id': questionnaireId,
            'hmac_token': hmacToken,
          },
        });
      }
      /**
       * @param questionnaireId
       * @param hmacToken
       * @returns any
       * @throws ApiError
       */
      public static apiQuestionnairesRequestsValidateTokenAnswerQuestionCreate(
        questionnaireId: string,
        hmacToken: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/questionnaires/requests/validate-token/{questionnaire_id}/{hmac_token}/answer-question',
          path: {
            'questionnaire_id': questionnaireId,
            'hmac_token': hmacToken,
          },
        });
      }
      /**
       * Allows a portal user to delegate a questionnaire to another person.
       * No login required - uses HMAC token authentication.
       * @param questionnaireId
       * @param hmacToken
       * @param data
       * @returns DelegateQuestionnaire
       * @throws ApiError
       */
      public static apiQuestionnairesRequestsDelegateCreate(
        questionnaireId: string,
        hmacToken: string,
        data: DelegateQuestionnaire,
      ): CancelablePromise<DelegateQuestionnaire> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/questionnaires/requests/{questionnaire_id}/{hmac_token}/delegate',
          path: {
            'questionnaire_id': questionnaireId,
            'hmac_token': hmacToken,
          },
          body: data,
        });
      }
      /**
       * Allows a portal user to re-delegate (reassign) an existing delegation to a different person.
       * This soft-deletes the old delegation and all its descendants, then creates a new delegation.
       * No login required - uses HMAC token authentication.
       * @param questionnaireId
       * @param hmacToken
       * @param data
       * @returns RedelegateQuestionnaire
       * @throws ApiError
       */
      public static apiQuestionnairesRequestsRedelegateCreate(
        questionnaireId: string,
        hmacToken: string,
        data: RedelegateQuestionnaire,
      ): CancelablePromise<RedelegateQuestionnaire> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/questionnaires/requests/{questionnaire_id}/{hmac_token}/redelegate',
          path: {
            'questionnaire_id': questionnaireId,
            'hmac_token': hmacToken,
          },
          body: data,
        });
      }
      /**
       * @param reportDateId
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiRetrieveInformationRequestStatusRead(
        reportDateId: string,
        page?: number,
      ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<InformationRequestStatus>;
      }> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/retrieve-information-request-status/{report_date_id}',
          path: {
            'report_date_id': reportDateId,
          },
          query: {
            'page': page,
          },
        });
      }
      /**
       * @param firmId
       * @returns SCIMConfigurationRead
       * @throws ApiError
       */
      public static apiScimConfigurationFirmRead(
        firmId: string,
      ): CancelablePromise<SCIMConfigurationRead> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/scim/configuration/firm/{firm_id}',
          path: {
            'firm_id': firmId,
          },
        });
      }
      /**
       * Update the SCIM configuration for the firm. Only one configuration can exist per firm.
       * @param configurationId
       * @param data
       * @returns SCIMConfigurationRead
       * @throws ApiError
       */
      public static apiScimConfigurationUpdate(
        configurationId: string,
        data: SCIMConfigurationUpdate,
      ): CancelablePromise<SCIMConfigurationRead> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/scim/configuration/{configuration_id}',
          path: {
            'configuration_id': configurationId,
          },
          body: data,
        });
      }
      /**
       * @param configurationId
       * @returns any
       * @throws ApiError
       */
      public static apiScimConfigurationPartialUpdate(
        configurationId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/scim/configuration/{configuration_id}',
          path: {
            'configuration_id': configurationId,
          },
        });
      }
      /**
       * Concrete view for bulk saving spreadsheet note instances.
       * @param pageType
       * @param capTable
       * @param fundOwnership
       * @param financialStatement
       * @param fundMeasurementDate
       * @param allocation
       * @param valuationApproach
       * @param valuationApproachValuation
       * @param companyMeasurementDate
       * @param marketAdjustment
       * @param fundInvestmentOwnership
       * @returns SpreadsheetNote
       * @throws ApiError
       */
      public static apiSpreadsheetNotesList(
        pageType?: string,
        capTable?: string,
        fundOwnership?: string,
        financialStatement?: string,
        fundMeasurementDate?: string,
        allocation?: string,
        valuationApproach?: string,
        valuationApproachValuation?: string,
        companyMeasurementDate?: string,
        marketAdjustment?: string,
        fundInvestmentOwnership?: string,
      ): CancelablePromise<Array<SpreadsheetNote>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/spreadsheet-notes/',
          query: {
            'page_type': pageType,
            'cap_table': capTable,
            'fund_ownership': fundOwnership,
            'financial_statement': financialStatement,
            'fund_measurement_date': fundMeasurementDate,
            'allocation': allocation,
            'valuation_approach': valuationApproach,
            'valuation_approach__valuation': valuationApproachValuation,
            'company_measurement_date': companyMeasurementDate,
            'market_adjustment': marketAdjustment,
            'fund_investment_ownership': fundInvestmentOwnership,
          },
        });
      }
      /**
       * Concrete view for bulk saving spreadsheet note instances.
       * @param data
       * @returns SpreadsheetNoteGet
       * @throws ApiError
       */
      public static apiSpreadsheetNotesCreate(
        data: Array<SpreadsheetNote>,
      ): CancelablePromise<Array<SpreadsheetNoteGet>> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/spreadsheet-notes/',
          body: data,
        });
      }
      /**
       * Concrete view for retrieving SpreadsheetNote instances.
       * @param id A unique integer value identifying this spreadsheet note.
       * @returns SpreadsheetNoteGet
       * @throws ApiError
       */
      public static apiSpreadsheetNotesRead(
        id: number,
      ): CancelablePromise<SpreadsheetNoteGet> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/spreadsheet-notes/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param tenantPublicUuid
       * @returns any
       * @throws ApiError
       */
      public static apiSsoAcsCreate(
        tenantPublicUuid: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/sso/acs/{tenant_public_uuid}',
          path: {
            'tenant_public_uuid': tenantPublicUuid,
          },
        });
      }
      /**
       * Discover tenant based on user email. If tenant is not found, suggest standard password login as next step and login_url is null.
       * @param data
       * @returns TenantDiscoveryResponse
       * @throws ApiError
       */
      public static apiSsoDiscoverCreate(
        data: TenantDiscovery,
      ): CancelablePromise<TenantDiscoveryResponse> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/sso/discover',
          body: data,
        });
      }
      /**
       * Exchange an SSO exchange ticket for JWT tokens and user information.
       * @param data
       * @returns TokenExchangeResponse
       * @throws ApiError
       */
      public static apiSsoExchangeCreate(
        data: TokenExchangeRequest,
      ): CancelablePromise<TokenExchangeResponse> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/sso/exchange',
          body: data,
        });
      }
      /**
       * Read metadata URL (if not null) ans save more tenant configuration for SSO integration.
       * @param data
       * @returns IntegrationMetadata
       * @throws ApiError
       */
      public static apiSsoIntegrationsMetadataCreate(
        data: IntegrationMetadata,
      ): CancelablePromise<IntegrationMetadata> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/sso/integrations/metadata',
          body: data,
        });
      }
      /**
       * Initiate SSO login for a specific tenant.
       * @param t Ephemeral ticket to initiate SSO login for a given tenant. Will be disposed after first use.
       * @returns any
       * @throws ApiError
       */
      public static apiSsoLoginList(
        t: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/sso/login',
          query: {
            't': t,
          },
          errors: {
            302: `Redirect to IdP SSO URL`,
          },
        });
      }
      /**
       * @param firmId
       * @returns TenantInformation
       * @throws ApiError
       */
      public static apiSsoTenantRead(
        firmId: string,
      ): CancelablePromise<TenantInformation> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/sso/tenant/{firm_id}',
          path: {
            'firm_id': firmId,
          },
        });
      }
      /**
       * @param companyId
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsCompanyPaymentMethodsList(
        companyId: string,
        page?: number,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/subscriptions/company/{company_id}/payment-methods',
          path: {
            'company_id': companyId,
          },
          query: {
            'page': page,
          },
        });
      }
      /**
       * @param companyId
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsCompanyPaymentMethodsCreate(
        companyId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/subscriptions/company/{company_id}/payment-methods',
          path: {
            'company_id': companyId,
          },
        });
      }
      /**
       * @param companyId
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsCompanyPaymentsRead(
        companyId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/subscriptions/company/{company_id}/payments',
          path: {
            'company_id': companyId,
          },
        });
      }
      /**
       * @param companyId
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsCompanySubscriptionRead(
        companyId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/subscriptions/company/{company_id}/subscription',
          path: {
            'company_id': companyId,
          },
        });
      }
      /**
       * @param companyId
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsCompanySubscriptionUpdate(
        companyId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/subscriptions/company/{company_id}/subscription',
          path: {
            'company_id': companyId,
          },
        });
      }
      /**
       * @param companyId
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsCompanySubscriptionPartialUpdate(
        companyId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/subscriptions/company/{company_id}/subscription',
          path: {
            'company_id': companyId,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsInitiatePaymentCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/subscriptions/initiate-payment',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiSubscriptionsSubscriptionSetupIntentCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/subscriptions/subscription/setup-intent',
        });
      }
      /**
       * @param data
       * @returns CreateOnboardingTasks
       * @throws ApiError
       */
      public static apiTasksOnboardingCreate(
        data: CreateOnboardingTasks,
      ): CancelablePromise<CreateOnboardingTasks> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/tasks/onboarding',
          body: data,
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiTasksShareCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/tasks/share',
        });
      }
      /**
       * @param cmdId
       * @returns Portal
       * @throws ApiError
       */
      public static apiTasksPortalLinksRead(
        cmdId: string,
      ): CancelablePromise<Portal> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/tasks/{cmd_id}/portal-links',
          path: {
            'cmd_id': cmdId,
          },
        });
      }
      /**
       * @param taskId
       * @returns TaskDetailedProgress
       * @throws ApiError
       */
      public static apiTasksProgressDetailRead(
        taskId: string,
      ): CancelablePromise<TaskDetailedProgress> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/tasks/{task_id}/progress-detail',
          path: {
            'task_id': taskId,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiTotpCreateList(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/totp/create/',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiTotpDeleteCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/totp/delete/',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiTotpGetList(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/totp/get/',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiTotpStaticCreateCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/totp/static/create/',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiTotpStaticGetList(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/totp/static/get/',
        });
      }
      /**
       * @param token
       * @returns any
       * @throws ApiError
       */
      public static apiTotpStaticVerifyCreate(
        token: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/totp/static/verify/{token}/',
          path: {
            'token': token,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiTotpUpdateCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/totp/update/',
        });
      }
      /**
       * @param token
       * @returns any
       * @throws ApiError
       */
      public static apiTotpVerifyCreate(
        token: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/totp/verify/{token}/',
          path: {
            'token': token,
          },
        });
      }
      /**
       * @param informationRequestStatusId
       * @param data
       * @returns TaskDetailedProgress
       * @throws ApiError
       */
      public static apiUpdateInformationRequestStatusUpdate(
        informationRequestStatusId: string,
        data: UpdateDocumentAndQuestionnaireTasks,
      ): CancelablePromise<Array<TaskDetailedProgress>> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/update-information-request-status/{information_request_status_id}',
          path: {
            'information_request_status_id': informationRequestStatusId,
          },
          body: data,
        });
      }
      /**
       * @param informationRequestStatusId
       * @param data
       * @returns UpdateDocumentAndQuestionnaireTasks
       * @throws ApiError
       */
      public static apiUpdateInformationRequestStatusPartialUpdate(
        informationRequestStatusId: string,
        data: UpdateDocumentAndQuestionnaireTasks,
      ): CancelablePromise<UpdateDocumentAndQuestionnaireTasks> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/update-information-request-status/{information_request_status_id}',
          path: {
            'information_request_status_id': informationRequestStatusId,
          },
          body: data,
        });
      }
      /**
       * @returns CustomUser
       * @throws ApiError
       */
      public static apiUserRead(): CancelablePromise<CustomUser> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/user',
        });
      }
      /**
       * @param id A unique integer value identifying this user.
       * @returns CustomUser
       * @throws ApiError
       */
      public static apiUserRead1(
        id: number,
      ): CancelablePromise<CustomUser> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/user/{id}',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @returns any
       * @throws ApiError
       */
      public static apiUserDeleteUpdate(
        id: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/user/{id}/delete',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @returns any
       * @throws ApiError
       */
      public static apiUserDeletePartialUpdate(
        id: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/user/{id}/delete',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @returns void
       * @throws ApiError
       */
      public static apiUserDeleteDelete(
        id: string,
      ): CancelablePromise<void> {
        return __request(OpenAPI, {
          method: 'DELETE',
          url: '/api/user/{id}/delete',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @returns UserPermissionWithPath
       * @throws ApiError
       */
      public static apiUserLowerPermissionsList(
        id: string,
      ): CancelablePromise<Array<UserPermissionWithPath>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/user/{id}/lower-permissions',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @param id
       * @param firmId
       * @returns UserPermission
       * @throws ApiError
       */
      public static apiUserPermissionsRead(
        id: string,
        firmId: string,
      ): CancelablePromise<Array<UserPermission>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/user/{id}/permissions/{firm_id}',
          path: {
            'id': id,
            'firm_id': firmId,
          },
        });
      }
      /**
       * User listing view that supports both full and slim data via query parameter.
       * @param search A search term.
       * @returns any
       * @throws ApiError
       */
      public static apiUsersList(
        search?: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/users',
          query: {
            'search': search,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiUsersCreateBulkUsersCreate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/users/create-bulk-users',
        });
      }
      /**
       * @param id A unique integer value identifying this user.
       * @returns UserWithPermissions
       * @throws ApiError
       */
      public static apiUsersFirmUsersRead(
        id: number,
      ): CancelablePromise<Array<UserWithPermissions>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/users/firm_users/{id}/',
          path: {
            'id': id,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiUsersPermissionsUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/users/permissions',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiUsersPermissionsPartialUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/users/permissions',
        });
      }
      /**
       * @param id
       * @param companyId
       * @returns any
       * @throws ApiError
       */
      public static apiUsersPermissionsUpdate1(
        id: string,
        companyId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/users/permissions/{id}/{company_id}',
          path: {
            'id': id,
            'company_id': companyId,
          },
        });
      }
      /**
       * @param id
       * @param companyId
       * @returns any
       * @throws ApiError
       */
      public static apiUsersPermissionsPartialUpdate1(
        id: string,
        companyId: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/users/permissions/{id}/{company_id}',
          path: {
            'id': id,
            'company_id': companyId,
          },
        });
      }
      /**
       * @param id
       * @param companyId
       * @returns void
       * @throws ApiError
       */
      public static apiUsersPermissionsDelete(
        id: string,
        companyId: string,
      ): CancelablePromise<void> {
        return __request(OpenAPI, {
          method: 'DELETE',
          url: '/api/users/permissions/{id}/{company_id}',
          path: {
            'id': id,
            'company_id': companyId,
          },
        });
      }
      /**
       * User listing view that only returns staff users.
       * @param search A search term.
       * @returns SlimUser
       * @throws ApiError
       */
      public static apiUsersStaffList(
        search?: string,
      ): CancelablePromise<Array<SlimUser>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/users/staff',
          query: {
            'search': search,
          },
        });
      }
      /**
       * @param alId
       * @returns ValuationAllocationModel
       * @throws ApiError
       */
      public static apiValuationAllocationRead(
        alId: string,
      ): CancelablePromise<ValuationAllocationModel> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation-allocation/{al_id}',
          path: {
            'al_id': alId,
          },
        });
      }
      /**
       * @param alId
       * @param data
       * @returns ValuationAllocationModel
       * @throws ApiError
       */
      public static apiValuationAllocationUpdate(
        alId: string,
        data: ValuationAllocationModel,
      ): CancelablePromise<ValuationAllocationModel> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation-allocation/{al_id}',
          path: {
            'al_id': alId,
          },
          body: data,
        });
      }
      /**
       * @param alId
       * @param data
       * @returns ValuationAllocationModel
       * @throws ApiError
       */
      public static apiValuationAllocationPartialUpdate(
        alId: string,
        data: ValuationAllocationModel,
      ): CancelablePromise<ValuationAllocationModel> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation-allocation/{al_id}',
          path: {
            'al_id': alId,
          },
          body: data,
        });
      }
      /**
       * @param alId
       * @returns NewValuationAllocationVersion
       * @throws ApiError
       */
      public static apiValuationAllocationNewVersionRead(
        alId: string,
      ): CancelablePromise<NewValuationAllocationVersion> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation-allocation/{al_id}/new-version',
          path: {
            'al_id': alId,
          },
        });
      }
      /**
       * @param alId
       * @param data
       * @returns NewValuationAllocationVersion
       * @throws ApiError
       */
      public static apiValuationAllocationNewVersionUpdate(
        alId: string,
        data: NewValuationAllocationVersion,
      ): CancelablePromise<NewValuationAllocationVersion> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation-allocation/{al_id}/new-version',
          path: {
            'al_id': alId,
          },
          body: data,
        });
      }
      /**
       * @param alId
       * @param data
       * @returns NewValuationAllocationVersion
       * @throws ApiError
       */
      public static apiValuationAllocationNewVersionPartialUpdate(
        alId: string,
        data: NewValuationAllocationVersion,
      ): CancelablePromise<NewValuationAllocationVersion> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation-allocation/{al_id}/new-version',
          path: {
            'al_id': alId,
          },
          body: data,
        });
      }
      /**
       * @param measurementDateId
       * @param allocationVersion
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiValuationApproachesRead(
        measurementDateId: string,
        allocationVersion: string,
        page?: number,
      ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<ValuationApproachModel>;
      }> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/approaches/{measurement_date_id}/{allocation_version}/',
          path: {
            'measurement_date_id': measurementDateId,
            'allocation_version': allocationVersion,
          },
          query: {
            'page': page,
          },
        });
      }
      /**
       * @param data
       * @returns BulkValuationUpdateResponse
       * @throws ApiError
       */
      public static apiValuationBulkUpdateCreate(
        data: Array<BulkValuationUpdate>,
      ): CancelablePromise<Array<BulkValuationUpdateResponse>> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/valuation/bulk-update',
          body: data,
        });
      }
      /**
       * @param firmId
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiValuationCompGroupFirmRead(
        firmId: string,
        page?: number,
      ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<CompGroupListCreate>;
      }> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/comp-group/firm/{firm_id}',
          path: {
            'firm_id': firmId,
          },
          query: {
            'page': page,
          },
        });
      }
      /**
       * @param firmId
       * @param data
       * @returns CompGroupListCreate
       * @throws ApiError
       */
      public static apiValuationCompGroupFirmCreate(
        firmId: string,
        data: CompGroupListCreate,
      ): CancelablePromise<CompGroupListCreate> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/valuation/comp-group/firm/{firm_id}',
          path: {
            'firm_id': firmId,
          },
          body: data,
        });
      }
      /**
       * @param firmId
       * @param date
       * @returns FirmCompanyMeasurementDate
       * @throws ApiError
       */
      public static apiValuationFirmRead(
        firmId: string,
        date: string,
      ): CancelablePromise<Array<FirmCompanyMeasurementDate>> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/firm/{firm_id}/{date}/',
          path: {
            'firm_id': firmId,
            'date': date,
          },
        });
      }
      /**
       * @param mdPk
       * @param currencies A currency pair in the $<TARGET><SOURCE>: format (e.g., $USDGBP:)
       * @param currencyDate The date for the exchange rate in MM/DD/YYYY or YYYY-MM-DD format
       * @returns any Exchange rate data
       * @throws ApiError
       */
      public static apiValuationGetExchangeRateRead(
        mdPk: string,
        currencies?: string,
        currencyDate?: string,
      ): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/get-exchange-rate/{md_pk}',
          path: {
            'md_pk': mdPk,
          },
          query: {
            'currencies': currencies,
            'currency_date': currencyDate,
          },
          errors: {
            400: `Bad Request`,
            404: `Not Found`,
            500: `Internal Server Error`,
          },
        });
      }
      /**
       * @param transactionId
       * @returns TransactionId
       * @throws ApiError
       */
      public static apiValuationGetTransactionInformationRead(
        transactionId: string,
      ): CancelablePromise<TransactionId> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/get-transaction-information/{transaction_id}/',
          path: {
            'transaction_id': transactionId,
          },
        });
      }
      /**
       * @param mdPk
       * @returns GPC
       * @throws ApiError
       */
      public static apiValuationGpcRead(
        mdPk: string,
      ): CancelablePromise<GPC> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/gpc/{md_pk}',
          path: {
            'md_pk': mdPk,
          },
        });
      }
      /**
       * @param mdPk
       * @param data
       * @returns GPC
       * @throws ApiError
       */
      public static apiValuationGpcUpdate(
        mdPk: string,
        data: GPC,
      ): CancelablePromise<GPC> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation/gpc/{md_pk}',
          path: {
            'md_pk': mdPk,
          },
          body: data,
        });
      }
      /**
       * @param mdPk
       * @param data
       * @returns GPC
       * @throws ApiError
       */
      public static apiValuationGpcPartialUpdate(
        mdPk: string,
        data: GPC,
      ): CancelablePromise<GPC> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation/gpc/{md_pk}',
          path: {
            'md_pk': mdPk,
          },
          body: data,
        });
      }
      /**
       * @param valuationId
       * @param data
       * @returns BulkValuationUpdateResponse
       * @throws ApiError
       */
      public static apiValuationIndividualUpdateUpdate(
        valuationId: string,
        data: BulkValuationUpdate,
      ): CancelablePromise<BulkValuationUpdateResponse> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation/individual-update/{valuation_id}',
          path: {
            'valuation_id': valuationId,
          },
          body: data,
        });
      }
      /**
       * @param valuationId
       * @param data
       * @returns BulkValuationUpdateResponse
       * @throws ApiError
       */
      public static apiValuationIndividualUpdatePartialUpdate(
        valuationId: string,
        data: BulkValuationUpdate,
      ): CancelablePromise<BulkValuationUpdateResponse> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation/individual-update/{valuation_id}',
          path: {
            'valuation_id': valuationId,
          },
          body: data,
        });
      }
      /**
       * @param valuationId
       * @param updatedAt
       * @returns BulkValuationUpdateResponse
       * @throws ApiError
       */
      public static apiValuationIndividualUpdatePollRead(
        valuationId: string,
        updatedAt: string,
      ): CancelablePromise<BulkValuationUpdateResponse> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/individual_update_poll/{valuation_id}/{updated_at}/',
          path: {
            'valuation_id': valuationId,
            'updated_at': updatedAt,
          },
        });
      }
      /**
       * @param mdPk
       * @returns GPC
       * @throws ApiError
       */
      public static apiValuationPcListRead(
        mdPk: string,
      ): CancelablePromise<GPC> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/pc-list/{md_pk}',
          path: {
            'md_pk': mdPk,
          },
        });
      }
      /**
       * @param mdPk
       * @param data
       * @returns GPC
       * @throws ApiError
       */
      public static apiValuationPcListUpdate(
        mdPk: string,
        data: GPC,
      ): CancelablePromise<GPC> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation/pc-list/{md_pk}',
          path: {
            'md_pk': mdPk,
          },
          body: data,
        });
      }
      /**
       * @param mdPk
       * @param data
       * @returns GPC
       * @throws ApiError
       */
      public static apiValuationPcListPartialUpdate(
        mdPk: string,
        data: GPC,
      ): CancelablePromise<GPC> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation/pc-list/{md_pk}',
          path: {
            'md_pk': mdPk,
          },
          body: data,
        });
      }
      /**
       * @param id A unique integer value identifying this valuation approach gpc.
       * @param date
       * @param refreshDate
       * @returns boolean Boolean response
       * @throws ApiError
       */
      public static apiValuationPollRefreshCompsRead(
        id: number,
        date: string,
        refreshDate: string,
      ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/poll-refresh-comps/{id}/{date}/{refresh_date}/',
          path: {
            'id': id,
            'date': date,
            'refresh_date': refreshDate,
          },
        });
      }
      /**
       * Create a new public company refresh.
       * @param data
       * @returns boolean Updated
       * @throws ApiError
       */
      public static apiValuationRefreshCompsCreate(
        data: RefreshComps,
      ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/valuation/refresh-comps/',
          body: data,
          errors: {
            400: `Bad Request`,
          },
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiValuationTickerSearchRead(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/ticker-search',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiValuationTickerSearchUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation/ticker-search',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiValuationTickerSearchPartialUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation/ticker-search',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiValuationTransferOwnershipUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation/transfer-ownership',
        });
      }
      /**
       * @returns any
       * @throws ApiError
       */
      public static apiValuationTransferOwnershipPartialUpdate(): CancelablePromise<any> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation/transfer-ownership',
        });
      }
      /**
       * @param alId
       * @returns ValuationModel
       * @throws ApiError
       */
      public static apiValuationRead(
        alId: string,
      ): CancelablePromise<ValuationModel> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuation/{al_id}',
          path: {
            'al_id': alId,
          },
        });
      }
      /**
       * @param alId
       * @param data
       * @returns ValuationModel
       * @throws ApiError
       */
      public static apiValuationUpdate(
        alId: string,
        data: ValuationModel,
      ): CancelablePromise<ValuationModel> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation/{al_id}',
          path: {
            'al_id': alId,
          },
          body: data,
        });
      }
      /**
       * @param alId
       * @param data
       * @returns ValuationModel
       * @throws ApiError
       */
      public static apiValuationPartialUpdate(
        alId: string,
        data: ValuationModel,
      ): CancelablePromise<ValuationModel> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation/{al_id}',
          path: {
            'al_id': alId,
          },
          body: data,
        });
      }
      /**
       * @param valuationId
       * @param data
       * @returns SetReadyForAudit
       * @throws ApiError
       */
      public static apiValuationReadyForAuditUpdate(
        valuationId: string,
        data: SetReadyForAudit,
      ): CancelablePromise<SetReadyForAudit> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuation/{valuation_id}/ready-for-audit',
          path: {
            'valuation_id': valuationId,
          },
          body: data,
        });
      }
      /**
       * @param valuationId
       * @param data
       * @returns SetReadyForAudit
       * @throws ApiError
       */
      public static apiValuationReadyForAuditPartialUpdate(
        valuationId: string,
        data: SetReadyForAudit,
      ): CancelablePromise<SetReadyForAudit> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuation/{valuation_id}/ready-for-audit',
          path: {
            'valuation_id': valuationId,
          },
          body: data,
        });
      }
      /**
       * @param data
       * @returns EffectiveTaxRateWriteModel
       * @throws ApiError
       */
      public static apiValuationsEffectiveTaxRateCreateCreate(
        data: EffectiveTaxRateWriteModel,
      ): CancelablePromise<EffectiveTaxRateWriteModel> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/valuations/effective-tax-rate/create',
          body: data,
        });
      }
      /**
       * @param companyMeasurementDate
       * @returns EffectiveTaxRateModel
       * @throws ApiError
       */
      public static apiValuationsEffectiveTaxRateRead(
        companyMeasurementDate: string,
      ): CancelablePromise<EffectiveTaxRateModel> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuations/effective-tax-rate/{company_measurement_date}',
          path: {
            'company_measurement_date': companyMeasurementDate,
          },
        });
      }
      /**
       * @param companyMeasurementDate
       * @param data
       * @returns EffectiveTaxRateModel
       * @throws ApiError
       */
      public static apiValuationsEffectiveTaxRateUpdate(
        companyMeasurementDate: string,
        data: EffectiveTaxRateModel,
      ): CancelablePromise<EffectiveTaxRateModel> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuations/effective-tax-rate/{company_measurement_date}',
          path: {
            'company_measurement_date': companyMeasurementDate,
          },
          body: data,
        });
      }
      /**
       * @param companyMeasurementDate
       * @param data
       * @returns EffectiveTaxRateModel
       * @throws ApiError
       */
      public static apiValuationsEffectiveTaxRatePartialUpdate(
        companyMeasurementDate: string,
        data: EffectiveTaxRateModel,
      ): CancelablePromise<EffectiveTaxRateModel> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuations/effective-tax-rate/{company_measurement_date}',
          path: {
            'company_measurement_date': companyMeasurementDate,
          },
          body: data,
        });
      }
      /**
       * @param id A unique integer value identifying this effective tax rate.
       * @param data
       * @returns EffectiveTaxRateWriteModel
       * @throws ApiError
       */
      public static apiValuationsEffectiveTaxRateUpdateUpdate(
        id: number,
        data: EffectiveTaxRateWriteModel,
      ): CancelablePromise<EffectiveTaxRateWriteModel> {
        return __request(OpenAPI, {
          method: 'PUT',
          url: '/api/valuations/effective-tax-rate/{id}/update',
          path: {
            'id': id,
          },
          body: data,
        });
      }
      /**
       * @param id A unique integer value identifying this effective tax rate.
       * @param data
       * @returns EffectiveTaxRateWriteModel
       * @throws ApiError
       */
      public static apiValuationsEffectiveTaxRateUpdatePartialUpdate(
        id: number,
        data: EffectiveTaxRateWriteModel,
      ): CancelablePromise<EffectiveTaxRateWriteModel> {
        return __request(OpenAPI, {
          method: 'PATCH',
          url: '/api/valuations/effective-tax-rate/{id}/update',
          path: {
            'id': id,
          },
          body: data,
        });
      }
      /**
       * @param alId
       * @param page A page number within the paginated result set.
       * @returns any
       * @throws ApiError
       */
      public static apiValuationsRead(
        alId: string,
        page?: number,
      ): CancelablePromise<{
        count: number;
        next?: string | null;
        previous?: string | null;
        results: Array<ValuationModel>;
      }> {
        return __request(OpenAPI, {
          method: 'GET',
          url: '/api/valuations/{al_id}',
          path: {
            'al_id': alId,
          },
          query: {
            'page': page,
          },
        });
      }
      /**
       * @param data
       * @returns Scenario
       * @throws ApiError
       */
      public static apiWaterfallCreate(
        data: ScenarioValuesCalculation,
      ): CancelablePromise<Scenario> {
        return __request(OpenAPI, {
          method: 'POST',
          url: '/api/waterfall',
          body: data,
        });
      }
    }
